export const treeDataPartner = `
[
  {
    "parent": null,
    "name": "root",
    "id": "root",
    "type": "title-only",
    "attributes": {}
  },
  {
    "id": "0",
    "name": "Start",
    "parent": "root",
    "type": "text-question",
    "index": 0,
    "attributes": {
      "question": "Choose your environment"
    }
  },
  {
    "id": "1",
    "name": "Laboratory or Industrial",
    "parent": "0",
    "type": "image-question",
    "index": 0,
    "attributes": {
      "image": "vinyl.png",
      "question": "Choose your material"
    }
  },
  {
    "id": "2",
    "name": "Polyurethane",
    "parent": "1",
    "type": "image-question",
    "index": 3,
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "poly.png"
    }
  },
  {
    "id": "3",
    "parent": "0",
    "name": "Office",
    "type": "image-question",
    "index": 2,
    "attributes": {
      "image": "mesh.png",
      "question": "Task chair or guest chair?"
    }
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "3175818b-31c6-47c8-9c15-fed710f6adae",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "2",
    "index": 1,
    "type": "text-question"
  },
  {
    "name": "Wood",
    "id": "70a4ebb2-f67f-4d55-9e73-d0915a983683",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "wood.png"
    },
    "parent": "1",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Task",
    "id": "4ced1c6b-59c4-4142-92cf-d14a79865884",
    "attributes": {
      "question": "Choose your material"
    },
    "parent": "3",
    "index": 0,
    "type": "text-question"
  },
  {
    "name": "Mesh",
    "id": "5a219c10-9991-49d9-b7ba-5992f53a5ba2",
    "attributes": {
      "question": "What type of seating do you prefer?",
      "image": "mesh.png"
    },
    "parent": "4ced1c6b-59c4-4142-92cf-d14a79865884",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "f5331a84-14fc-446e-bf2d-d3e197a69250",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "70a4ebb2-f67f-4d55-9e73-d0915a983683",
    "index": 0
  },
  {
    "name": "Standard Back Chair",
    "id": "67c8af2b-16cb-4a8b-96c0-65c4eea09f60",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "wood-reg-chair.png"
    },
    "parent": "f5331a84-14fc-446e-bf2d-d3e197a69250",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Round Tube Base",
    "id": "bfba7239-faf4-4391-a8c8-53217b6eb8ae",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "67c8af2b-16cb-4a8b-96c0-65c4eea09f60",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "WDHCH-RT",
    "id": "6bff120b-a579-4312-9829-ca556d8d760a",
    "attributes": {
      "defaultSKU": "WDHCH-RT-RC"
    },
    "parent": "bfba7239-faf4-4391-a8c8-53217b6eb8ae",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Chrome Base",
    "id": "70fb09e8-8cf8-43e4-980d-b0014a3e5f0c",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "67c8af2b-16cb-4a8b-96c0-65c4eea09f60",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "WDHCH-CR",
    "id": "b0f649f6-5e9e-4142-b959-1ede57b57f76",
    "attributes": {
      "defaultSKU": "WDHCH-CR-CC"
    },
    "parent": "70fb09e8-8cf8-43e4-980d-b0014a3e5f0c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Stool",
    "id": "76d57c2b-424a-47ff-9b63-2c4d66cbfae2",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "wood-reg-stool.png"
    },
    "parent": "f5331a84-14fc-446e-bf2d-d3e197a69250",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Black Nylon Base",
    "id": "695466ee-50b1-494e-89dc-1841ad1d1969",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "76d57c2b-424a-47ff-9b63-2c4d66cbfae2",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "790410e8-b7c7-49b0-a392-063d2464a09d",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "76d57c2b-424a-47ff-9b63-2c4d66cbfae2",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "WDHSO-RG",
    "id": "fbd8e5f6-5961-416d-b6d4-ab84fbd0dbbd",
    "attributes": {
      "defaultSKU": "WDHSO-RG-RC"
    },
    "parent": "695466ee-50b1-494e-89dc-1841ad1d1969",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "WDHSO-RT",
    "id": "3289abd9-ebb0-4d8f-bb3f-417374ab32b7",
    "attributes": {
      "defaultSKU": "WDHSO-RT-RC"
    },
    "parent": "790410e8-b7c7-49b0-a392-063d2464a09d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Oxford",
    "id": "9aad614a-4cce-4a72-b500-444413491642",
    "attributes": {
      "image": "oxford.png"
    },
    "parent": "5a219c10-9991-49d9-b7ba-5992f53a5ba2",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Fabric",
    "id": "b6dd003f-fb43-45ab-9dfc-8acbc72e1e7f",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "fabric.png"
    },
    "parent": "4ced1c6b-59c4-4142-92cf-d14a79865884",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Windrowe",
    "id": "3660de56-a1b1-4931-b037-808dfe68d752",
    "attributes": {
      "image": "windrowe.png"
    },
    "parent": "5a219c10-9991-49d9-b7ba-5992f53a5ba2",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "MOD-MDHCH-RG",
    "id": "f8422549-54c1-4491-8ff4-f7dd6c515845",
    "attributes": {
      "defaultSKU": "MOD-MDHCH-RG-C2-A2-RC"
    },
    "parent": "9aad614a-4cce-4a72-b500-444413491642",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "EXE-MDHCH-RG",
    "id": "cb00de8b-995c-435f-9606-825a99b08831",
    "attributes": {
      "defaultSKU": "EXE-MDHCH-RG-H0-A2-RC"
    },
    "parent": "3660de56-a1b1-4931-b037-808dfe68d752",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "5bfc141f-c6ef-4f80-ad04-19e6ad25cb6a",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "b6dd003f-fb43-45ab-9dfc-8acbc72e1e7f",
    "index": 0
  },
  {
    "name": "Standard Back Chair",
    "id": "842c5498-5909-4695-9719-f57b14730b93",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric.png"
    },
    "parent": "5bfc141f-c6ef-4f80-ad04-19e6ad25cb6a",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "2870ab33-2c52-4d84-8d39-8a8fc07ee79c",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "842c5498-5909-4695-9719-f57b14730b93",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "f65b27f8-5bfa-4df0-9316-2ebb51ec6861",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "76d57c2b-424a-47ff-9b63-2c4d66cbfae2",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "WDHSO-CR",
    "id": "d2b5353c-867a-46e9-a67f-d8f732f0b0e0",
    "attributes": {
      "defaultSKU": "WDHSO-CR-CC"
    },
    "parent": "f65b27f8-5bfa-4df0-9316-2ebb51ec6861",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Black Nylon Base",
    "id": "da96d72d-1f45-4a88-b82a-2d65d09b8688",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "67c8af2b-16cb-4a8b-96c0-65c4eea09f60",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "WDHCH-RG",
    "id": "f41175a9-3097-41cb-84ae-c7c9b2cafa55",
    "attributes": {
      "defaultSKU": "WDHCH-RG-RC"
    },
    "parent": "da96d72d-1f45-4a88-b82a-2d65d09b8688",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "33033a61-929e-4cd7-bdc3-550cb885223e",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "70a4ebb2-f67f-4d55-9e73-d0915a983683",
    "index": 1
  },
  {
    "name": "Standard Back Chair",
    "id": "51ad8ab8-42e9-46e5-a443-fcdd805ae825",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "wood-reg-chair.png"
    },
    "parent": "33033a61-929e-4cd7-bdc3-550cb885223e",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "962df5ac-9716-4c54-8f71-63a461ff5863",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "51ad8ab8-42e9-46e5-a443-fcdd805ae825",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "WMBCH-CR",
    "id": "558d19ce-5831-4ba1-9f0c-634eb24b999f",
    "attributes": {
      "defaultSKU": "WMBCH-CR-CF-CC"
    },
    "parent": "962df5ac-9716-4c54-8f71-63a461ff5863",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Stool",
    "id": "26c4e6c4-5986-479f-86d3-4b2f65d3f6be",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "wood-reg-stool.png"
    },
    "parent": "33033a61-929e-4cd7-bdc3-550cb885223e",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Black Nylon Base",
    "id": "c002d746-6035-4ae7-8fd1-a51f25786c81",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "26c4e6c4-5986-479f-86d3-4b2f65d3f6be",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "642d4278-395f-4b5f-9b05-6113ab3d9833",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "26c4e6c4-5986-479f-86d3-4b2f65d3f6be",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "fd94c28e-4597-4c79-ab57-15f0df95568a",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "51ad8ab8-42e9-46e5-a443-fcdd805ae825",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "WMBCH-RG",
    "id": "88bc47b7-df9a-4929-b9f4-72a2bf0010c0",
    "attributes": {
      "defaultSKU": "WMBCH-RG-CF-RC"
    },
    "parent": "fd94c28e-4597-4c79-ab57-15f0df95568a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Round Tube Base",
    "id": "cca3d974-d7ba-4fc3-aa6d-5c3662395b0f",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "51ad8ab8-42e9-46e5-a443-fcdd805ae825",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "WMBCH-RT",
    "id": "da456300-3b4c-4576-9381-67362ca731c6",
    "attributes": {
      "defaultSKU": "WMBCH-RT-RG"
    },
    "parent": "cca3d974-d7ba-4fc3-aa6d-5c3662395b0f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Round Tube Base",
    "id": "6c2236be-8646-412b-ad13-f97dc29f2a11",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "26c4e6c4-5986-479f-86d3-4b2f65d3f6be",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "WMBSO-RT",
    "id": "b261b4d2-8216-4dcf-9c82-b6d0b3607533",
    "attributes": {
      "defaultSKU": "WMBSO-RT-RG"
    },
    "parent": "6c2236be-8646-412b-ad13-f97dc29f2a11",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "WMBSO-CR",
    "id": "2a2d9937-3eb5-44b9-9813-0dc4675bd8a7",
    "attributes": {
      "defaultSKU": "WMBSO-CR-CF-CC"
    },
    "parent": "642d4278-395f-4b5f-9b05-6113ab3d9833",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "WMBSO-RG",
    "id": "8ec36876-fcd2-4d2f-b94d-d9f7260a16f6",
    "attributes": {
      "defaultSKU": "WMBSO-RG-CF-RG"
    },
    "parent": "c002d746-6035-4ae7-8fd1-a51f25786c81",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "7b2a62e9-554a-4f7b-8dc9-48495532eb70",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "70a4ebb2-f67f-4d55-9e73-d0915a983683",
    "index": 2
  },
  {
    "name": "Stool",
    "id": "c51b47a3-5eb4-46bd-80ca-5055097505a2",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "wood-reg-stool.png"
    },
    "parent": "7b2a62e9-554a-4f7b-8dc9-48495532eb70",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Standard Back Chair",
    "id": "a2ccca87-08c7-4525-9f47-cae556b71ad8",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "wood-reg-chair.png"
    },
    "parent": "7b2a62e9-554a-4f7b-8dc9-48495532eb70",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "2ca2e048-f1ff-467c-8711-0f11787d91e6",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "c51b47a3-5eb4-46bd-80ca-5055097505a2",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "21957793-1f30-45ac-9587-98466f469b19",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "c51b47a3-5eb4-46bd-80ca-5055097505a2",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "WHBSO-CR",
    "id": "e7872eaf-8329-47c3-b7c1-a9fd34db76b7",
    "attributes": {
      "defaultSKU": "WHBSO-CR-CF-CC"
    },
    "parent": "2ca2e048-f1ff-467c-8711-0f11787d91e6",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "WHBSO-RG",
    "id": "c7fd076e-935e-44a1-93dc-70d8f317ff28",
    "attributes": {
      "defaultSKU": "WHBSO-RG-BF-RG"
    },
    "parent": "21957793-1f30-45ac-9587-98466f469b19",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Chrome Base",
    "id": "3d73f327-87ea-4abf-adba-28836bba9ebe",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "a2ccca87-08c7-4525-9f47-cae556b71ad8",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "fae11b5b-2c7a-4476-9666-dd36b8db56a8",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "a2ccca87-08c7-4525-9f47-cae556b71ad8",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "WHBCH-CR",
    "id": "9bb30b1b-1606-4045-83dd-32cb772c5ef7",
    "attributes": {
      "defaultSKU": "WHBCH-CR-CF-CC"
    },
    "parent": "3d73f327-87ea-4abf-adba-28836bba9ebe",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "WHBCH-RG",
    "id": "ffc2611c-5fb2-4bbf-a54a-b8ca84675f85",
    "attributes": {
      "defaultSKU": "WHBCH-RG-BF-RG"
    },
    "parent": "fae11b5b-2c7a-4476-9666-dd36b8db56a8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "ba01e548-46c2-4d70-aab8-6a90f83c2e34",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "2",
    "index": 0
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "2129e155-c63a-4a2e-b285-0a08617a2900",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "2",
    "index": 2
  },
  {
    "name": "Chair",
    "id": "163CEB8A-1CA9-49F6-80CC-DF765C08217E",
    "attributes": {
      "question": "What type of back do you prefer?",
      "image": "poly.png"
    },
    "parent": "ba01e548-46c2-4d70-aab8-6a90f83c2e34",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "14EE8302-26B2-47B3-958E-37A1DC4C5B54",
    "attributes": {
      "question": "What type of seat do you prefer?",
      "image": "poly-stool.png"
    },
    "parent": "ba01e548-46c2-4d70-aab8-6a90f83c2e34",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Chair",
    "id": "B987FE6F-AA9F-4564-A2BB-2182C4047781",
    "attributes": {
      "question": "What type of back do you prefer?",
      "image": "poly.png"
    },
    "parent": "3175818b-31c6-47c8-9c15-fed710f6adae",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "C41AD6CC-654D-485F-8824-2C85ADE9C8F4",
    "attributes": {
      "question": "What type of seat do you prefer?",
      "image": "poly-stool.png"
    },
    "parent": "3175818b-31c6-47c8-9c15-fed710f6adae",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Standard Back Chair",
    "id": "d0014fd5-33f9-4b1f-a624-c883ddafc06f",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly.png"
    },
    "parent": "163CEB8A-1CA9-49F6-80CC-DF765C08217E",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "4dd7e024-9651-4e15-a677-51c8d4ee0750",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly-med-chair.png"
    },
    "parent": "163CEB8A-1CA9-49F6-80CC-DF765C08217E",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Basic Stool",
    "id": "05409395-079d-497a-8b73-0a3b48245d66",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly-stool.png"
    },
    "parent": "14EE8302-26B2-47B3-958E-37A1DC4C5B54",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Tractor Stool",
    "id": "b7a96599-67c4-486c-9d90-5c8aefaf9846",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "tractor-stool.png"
    },
    "parent": "14EE8302-26B2-47B3-958E-37A1DC4C5B54",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Chair",
    "id": "4233B7F4-F468-4175-883C-86DAEA04A9DF",
    "attributes": {
      "question": "What type of back do you prefer?",
      "image": "poly.png"
    },
    "parent": "2129e155-c63a-4a2e-b285-0a08617a2900",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "3200E9AC-1486-4ECA-AB67-214271E74854",
    "attributes": {
      "question": "What type of seat do you prefer?",
      "image": "poly-stool.png"
    },
    "parent": "2129e155-c63a-4a2e-b285-0a08617a2900",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Standard Back Chair",
    "id": "61346388-3de5-4bd3-82f6-7c0f474b3bc4",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly.png"
    },
    "parent": "B987FE6F-AA9F-4564-A2BB-2182C4047781",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "0b545860-0735-46b1-8632-c8ace2fa4b76",
    "attributes": {
      "question": "What type of base do your prefer?",
      "image": "poly-med-chair.png"
    },
    "parent": "B987FE6F-AA9F-4564-A2BB-2182C4047781",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Basic Stool",
    "id": "6ffdab0d-e294-443b-b002-c802a1d08e2d",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly-stool.png"
    },
    "parent": "C41AD6CC-654D-485F-8824-2C85ADE9C8F4",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Tractor Stool",
    "id": "2b5ac3a1-8368-45dd-a97b-b6527c964717",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "tractor-stool.png"
    },
    "parent": "C41AD6CC-654D-485F-8824-2C85ADE9C8F4",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Standard Back Chair",
    "id": "a9dfcc55-d703-4615-bf16-5ef77ac9a3e6",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly.png"
    },
    "parent": "4233B7F4-F468-4175-883C-86DAEA04A9DF",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "9d19a723-e86a-4de5-9ef0-3b5aa2b88408",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly-med-chair.png"
    },
    "parent": "4233B7F4-F468-4175-883C-86DAEA04A9DF",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Basic Stool",
    "id": "ca651455-0ce7-413b-b6dd-70e42840feff",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "poly-stool.png"
    },
    "parent": "3200E9AC-1486-4ECA-AB67-214271E74854",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Tractor Stool",
    "id": "4346885f-59af-4759-9e2b-940dd2b9df8f",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "tractor-stool.png"
    },
    "parent": "3200E9AC-1486-4ECA-AB67-214271E74854",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "e0b527cb-0840-4a1a-827d-e99b7a205bc9",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "d0014fd5-33f9-4b1f-a624-c883ddafc06f",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "11a32451-efdb-4787-8b1d-5f31867191f8",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "4dd7e024-9651-4e15-a677-51c8d4ee0750",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "6bf97c3d-9307-4e44-85db-f457c2f4c305",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "d0014fd5-33f9-4b1f-a624-c883ddafc06f",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "6610ef4c-7a4f-47f4-9d76-7d6239e40d01",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "d0014fd5-33f9-4b1f-a624-c883ddafc06f",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "d3eee370-d4d7-4cfc-98a8-59213887e06a",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "4dd7e024-9651-4e15-a677-51c8d4ee0750",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "8dd1f895-8148-495b-952c-df0b34b83978",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "4dd7e024-9651-4e15-a677-51c8d4ee0750",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "efa8365e-72dd-4a48-8fa1-31d756b88ea8",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "05409395-079d-497a-8b73-0a3b48245d66",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "06536eeb-a4d3-45e6-a681-7b901cf4cc79",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "05409395-079d-497a-8b73-0a3b48245d66",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "24c43839-2017-4e8a-98ab-d74f9ba6c618",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "05409395-079d-497a-8b73-0a3b48245d66",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "ad23d1da-e424-4680-b258-e7547b4bf83b",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "b7a96599-67c4-486c-9d90-5c8aefaf9846",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "cc09fd4b-d99a-4da1-8767-fbe7fe761b2e",
    "attributes": {
      "question": "Choose your tilt option",
      "image": "black-base.png"
    },
    "parent": "b7a96599-67c4-486c-9d90-5c8aefaf9846",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "2f35e280-d683-4080-ac9b-be5990155643",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "61346388-3de5-4bd3-82f6-7c0f474b3bc4",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "ea45be0e-9011-473c-b435-47f9a439a801",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "61346388-3de5-4bd3-82f6-7c0f474b3bc4",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "5e5a5b4f-fe79-41bd-a9bb-5fd6ee35b876",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "61346388-3de5-4bd3-82f6-7c0f474b3bc4",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "c508210f-e899-4586-ad5e-20d6d2573c24",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "0b545860-0735-46b1-8632-c8ace2fa4b76",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "268ee186-3256-445a-991d-3367e964e48c",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "0b545860-0735-46b1-8632-c8ace2fa4b76",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "07842ff0-65eb-4430-850e-db4722bc9c9e",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "0b545860-0735-46b1-8632-c8ace2fa4b76",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "302abc74-b9d5-4686-978b-6a5c2a05f273",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "6ffdab0d-e294-443b-b002-c802a1d08e2d",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "5f4476a1-2105-44c8-ba24-528a1611fcbb",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "6ffdab0d-e294-443b-b002-c802a1d08e2d",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "7fe055ac-f056-4c33-8fec-8316a8efac44",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "6ffdab0d-e294-443b-b002-c802a1d08e2d",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "46f1b833-81a4-4eb5-99a5-03456a7e573f",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "2b5ac3a1-8368-45dd-a97b-b6527c964717",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "ab4793c8-e698-428b-a909-f7539d54893b",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "2b5ac3a1-8368-45dd-a97b-b6527c964717",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "dff139d2-271f-45e5-974d-6dd2f3dec6b3",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "a9dfcc55-d703-4615-bf16-5ef77ac9a3e6",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "ff97cf81-f940-43f8-8a39-b91791372ed0",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "a9dfcc55-d703-4615-bf16-5ef77ac9a3e6",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "da287b79-57d8-4ac4-be32-f7db73c702ad",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "9d19a723-e86a-4de5-9ef0-3b5aa2b88408",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "35d4d54a-93db-422c-9f32-60a56e55631e",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "9d19a723-e86a-4de5-9ef0-3b5aa2b88408",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "09e2a578-71cb-4a0a-8724-81d83b3c62cd",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "ca651455-0ce7-413b-b6dd-70e42840feff",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "49fc033d-9a06-427f-8585-476e47fd6e0f",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "ca651455-0ce7-413b-b6dd-70e42840feff",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "bc6351f9-600d-4646-97a1-68ffb573b917",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "4346885f-59af-4759-9e2b-940dd2b9df8f",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "4c8f4ab8-4bec-4f23-8654-668fe6cc1f23",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "4346885f-59af-4759-9e2b-940dd2b9df8f",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "PDHCH-CR",
    "id": "7c4c8c82-6d78-4e09-bb9c-43418e5c227b",
    "attributes": {
      "defaultSKU": "PDHCH-CR-T0-A1-CC-BLU"
    },
    "parent": "e0b527cb-0840-4a1a-827d-e99b7a205bc9",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHCH-RT",
    "id": "d59edae7-51ba-48f2-870c-9318599f6424",
    "attributes": {
      "defaultSKU": "PDHCH-RT-T0-A1-RG-BLU"
    },
    "parent": "6bf97c3d-9307-4e44-85db-f457c2f4c305",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHCH-RG",
    "id": "bdaa279a-1b57-4908-b154-f8745bfd253e",
    "attributes": {
      "defaultSKU": "PDHCH-RG-T0-A1-RC-BLU"
    },
    "parent": "6610ef4c-7a4f-47f4-9d76-7d6239e40d01",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHCH-MB-CR",
    "id": "bf84f8cf-ebe7-4385-9601-bc9695eea36d",
    "attributes": {
      "defaultSKU": "PDHCH-MB-CR-T0-A1-CC-BLU"
    },
    "parent": "11a32451-efdb-4787-8b1d-5f31867191f8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHCH-MB-RT",
    "id": "acf0205c-02b9-422b-b2cf-ef7531ece9eb",
    "attributes": {
      "defaultSKU": "PDHCH-MB-RT-T0-A1-RG-BLU"
    },
    "parent": "d3eee370-d4d7-4cfc-98a8-59213887e06a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHCH-MB-RG",
    "id": "5d8f5a33-c295-45bc-acdc-4dde3f8417f0",
    "attributes": {
      "defaultSKU": "PDHCH-MB-RG-T0-A1-RC-BLU"
    },
    "parent": "8dd1f895-8148-495b-952c-df0b34b83978",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHSO-CR",
    "id": "134ed20d-6cc4-45a9-adac-8c51ff1f2be2",
    "attributes": {
      "defaultSKU": "PDHSO-CR-CC"
    },
    "parent": "efa8365e-72dd-4a48-8fa1-31d756b88ea8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHSO-RT",
    "id": "05d71e89-95b9-45f1-8a87-d7044b3c7a8c",
    "attributes": {
      "defaultSKU": "PDHSO-RT-RG"
    },
    "parent": "06536eeb-a4d3-45e6-a681-7b901cf4cc79",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PDHSO-RG",
    "id": "119d5820-3ba0-4aeb-bd82-21d410c282af",
    "attributes": {
      "defaultSKU": "PDHSO-RG-RC"
    },
    "parent": "24c43839-2017-4e8a-98ab-d74f9ba6c618",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBCH-CR",
    "id": "963e8d3a-42c0-446a-a65c-8bc2dcedafa2",
    "attributes": {
      "defaultSKU": "PMBCH-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "2f35e280-d683-4080-ac9b-be5990155643",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBCH-RT",
    "id": "aac2a724-c15b-4cfa-a400-cb2338a12da4",
    "attributes": {
      "defaultSKU": "PMBCH-RT-T0-A1-RG-BLU"
    },
    "parent": "ea45be0e-9011-473c-b435-47f9a439a801",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBCH-RG",
    "id": "e4ca9161-c31f-442f-a7d8-fef1e0698e38",
    "attributes": {
      "defaultSKU": "PMBCH-RG-T0-A1-CF-RC-BLU"
    },
    "parent": "5e5a5b4f-fe79-41bd-a9bb-5fd6ee35b876",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBCH-MB-CR",
    "id": "2deede4b-b8ee-4707-8486-f0d37c279cc1",
    "attributes": {
      "defaultSKU": "PMBCH-MB-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "c508210f-e899-4586-ad5e-20d6d2573c24",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBCH-MB-RT",
    "id": "cb3d70c6-3fe8-4a65-8ead-4bbc6fd9d35f",
    "attributes": {
      "defaultSKU": "PMBCH-MB-RT-T0-A1-RG-BLU"
    },
    "parent": "268ee186-3256-445a-991d-3367e964e48c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBCH-MB-RG",
    "id": "11e70247-070c-43aa-9aab-18bf1cfdb56c",
    "attributes": {
      "defaultSKU": "PMBCH-MB-RG-T0-A1-CF-RC-BLU"
    },
    "parent": "07842ff0-65eb-4430-850e-db4722bc9c9e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBSO-CR",
    "id": "a8b8f22f-7c5e-4f5e-8fb8-aecfab310cb1",
    "attributes": {
      "defaultSKU": "PMBSO-CR-CF-CC"
    },
    "parent": "302abc74-b9d5-4686-978b-6a5c2a05f273",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBSO-RT",
    "id": "3a87805e-c896-4207-9f1e-69b234049492",
    "attributes": {
      "defaultSKU": "PMBSO-RT-RG"
    },
    "parent": "5f4476a1-2105-44c8-ba24-528a1611fcbb",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PMBSO-RG",
    "id": "e557f4f1-84e0-4ad1-8c45-5b44368c6c8a",
    "attributes": {
      "defaultSKU": "PMBSO-RG-CF-RC"
    },
    "parent": "7fe055ac-f056-4c33-8fec-8316a8efac44",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "With seat tilt",
    "id": "ca770a9a-3f56-40e1-b08b-ed4bdc402306",
    "attributes": {},
    "parent": "ab4793c8-e698-428b-a909-f7539d54893b",
    "index": 0,
    "type": "title-only"
  },
  {
    "name": "PHBCH-CR",
    "id": "c339260d-a832-4391-b948-e94921bab771",
    "attributes": {
      "defaultSKU": "PHBCH-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "dff139d2-271f-45e5-974d-6dd2f3dec6b3",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PHBCH-RG",
    "id": "14e6cbf3-ae9f-4199-986b-cfff3882eb9b",
    "attributes": {
      "defaultSKU": "PHBCH-RG-T0-A1-CF-RC-BLU"
    },
    "parent": "ff97cf81-f940-43f8-8a39-b91791372ed0",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PHBCH-MB-CR",
    "id": "54d8e2dc-3779-4747-8dd6-93e5a0a469f8",
    "attributes": {
      "defaultSKU": "PHBCH-MB-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "da287b79-57d8-4ac4-be32-f7db73c702ad",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PHBCH-MB-RG",
    "id": "ae3abeb5-b2fa-4e69-963a-90833aa46f14",
    "attributes": {
      "defaultSKU": "PHBCH-MB-RG-T0-A1-CF-RC-BLU"
    },
    "parent": "35d4d54a-93db-422c-9f32-60a56e55631e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PHBSO-CR",
    "id": "acf126b8-b168-4bf7-b502-b12f7b656432",
    "attributes": {
      "defaultSKU": "PHBSO-CR-CF-CC"
    },
    "parent": "09e2a578-71cb-4a0a-8724-81d83b3c62cd",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PHBSO-RG",
    "id": "39a625f4-d065-4192-b121-e7df44ab10dd",
    "attributes": {
      "defaultSKU": "PHBSO-RG-CF-RC"
    },
    "parent": "49fc033d-9a06-427f-8585-476e47fd6e0f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PTHBST-CR",
    "id": "d6270774-008c-4be3-b21d-75ef8f8fdb37",
    "attributes": {
      "defaultSKU": "PTHBST-CR-CF-RG-BLU"
    },
    "parent": "bc6351f9-600d-4646-97a1-68ffb573b917",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PTHBST-RG",
    "id": "e3f8ac40-4bda-404c-a5a6-aef04df74b30",
    "attributes": {
      "defaultSKU": "PTHBST-RG-CF-RG-BLU"
    },
    "parent": "4c8f4ab8-4bec-4f23-8654-668fe6cc1f23",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Vinyl",
    "id": "45d4d3b9-774c-40c8-9de7-62f51729c260",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "vinyl.png"
    },
    "parent": "1",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "dda18465-0692-496b-8ad5-191bfa3762cd",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "45d4d3b9-774c-40c8-9de7-62f51729c260",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "a9d84a72-7146-42dd-85ef-e0f728ac973d",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "45d4d3b9-774c-40c8-9de7-62f51729c260",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "5bf653c4-9bcb-42e1-9074-d48b1dcaa1af",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "45d4d3b9-774c-40c8-9de7-62f51729c260",
    "index": 2
  },
  {
    "name": "Standard Back Chair",
    "id": "60e3e6ce-3162-4a50-921a-7b20a2dfe000",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-reg-chair.png"
    },
    "parent": "dda18465-0692-496b-8ad5-191bfa3762cd",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "b1d497f2-f485-4451-b57e-6220b742fdac",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "med-chair.png"
    },
    "parent": "dda18465-0692-496b-8ad5-191bfa3762cd",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "d8855944-88f0-4cdd-b5f9-78affd899c22",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-stool.png"
    },
    "parent": "dda18465-0692-496b-8ad5-191bfa3762cd",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Stool With Back",
    "id": "d4594c24-5086-4d7c-8f41-996c705a5978",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-swb.png"
    },
    "parent": "dda18465-0692-496b-8ad5-191bfa3762cd",
    "index": 3,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "fb993ff0-4657-4b6c-9b2f-236b7f1fe7fd",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "60e3e6ce-3162-4a50-921a-7b20a2dfe000",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "0262f6f3-70ac-4c02-ace4-dd8e17ef213c",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "60e3e6ce-3162-4a50-921a-7b20a2dfe000",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "638a2eb5-7a7b-4d57-bded-bb2a9694bd51",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "60e3e6ce-3162-4a50-921a-7b20a2dfe000",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "2c47dc61-19d6-49bb-a529-9b4801722723",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "b1d497f2-f485-4451-b57e-6220b742fdac",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "5dded168-934f-4a9c-abd6-ab50f0568b7c",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "b1d497f2-f485-4451-b57e-6220b742fdac",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "55e8d5bb-4b1f-4739-9883-9afa88a3666d",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "b1d497f2-f485-4451-b57e-6220b742fdac",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "3838c022-0bfe-4f4c-95ed-a6ed44cf29bd",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "d8855944-88f0-4cdd-b5f9-78affd899c22",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "f88ca0e7-860c-433f-ae9e-e3721761cfdf",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "d8855944-88f0-4cdd-b5f9-78affd899c22",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "1e571359-878a-496f-8c32-A1f975cc55ad",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "d8855944-88f0-4cdd-b5f9-78affd899c22",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "5eed4623-27eb-4401-aea8-55967786dfbc",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "d4594c24-5086-4d7c-8f41-996c705a5978",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "ab5cad2b-4c4c-4d28-bf94-0e536d66eb18",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "d4594c24-5086-4d7c-8f41-996c705a5978",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "9bf3aded-4fd5-4c04-9951-cb49cfd2df7c",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "d4594c24-5086-4d7c-8f41-996c705a5978",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "VDHCH-CR",
    "id": "647f386c-75d7-4c11-ba46-3f68757d5247",
    "attributes": {
      "defaultSKU": "VDHCH-CR-T0-A1-CC-8801"
    },
    "parent": "fb993ff0-4657-4b6c-9b2f-236b7f1fe7fd",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHCH-RT",
    "id": "7da1a981-7d45-4ba0-b952-b81927b6fd81",
    "attributes": {
      "defaultSKU": "VDHCH-RT-T0-A1-RG-8801"
    },
    "parent": "0262f6f3-70ac-4c02-ace4-dd8e17ef213c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHCH-RG",
    "id": "9b9095ea-bb60-46ba-b87d-9d6598fd7969",
    "attributes": {
      "defaultSKU": "VDHCH-RG-T0-A1-RC-8801"
    },
    "parent": "638a2eb5-7a7b-4d57-bded-bb2a9694bd51",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHCH-MB-CR",
    "id": "55d1690d-075c-40ac-92fc-c1b3ec833cca",
    "attributes": {
      "defaultSKU": "VDHCH-MB-CR-T0-A1-CC-8801"
    },
    "parent": "2c47dc61-19d6-49bb-a529-9b4801722723",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHCH-MB-RT",
    "id": "cecada79-c865-4d3c-9baa-c509cf6c117d",
    "attributes": {
      "defaultSKU": "VDHCH-MB-RT-T0-A1-RG-8801"
    },
    "parent": "5dded168-934f-4a9c-abd6-ab50f0568b7c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHCH-MB-RG",
    "id": "9d209f18-4589-40e5-89a4-8387ef7f273e",
    "attributes": {
      "defaultSKU": "VDHCH-MB-RG-T0-A1-RC-8801"
    },
    "parent": "55e8d5bb-4b1f-4739-9883-9afa88a3666d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHSO-CR",
    "id": "fa4ec308-5979-450b-ab9a-600cbd0d8581",
    "attributes": {
      "defaultSKU": "VDHSO-CR-CC-8801"
    },
    "parent": "3838c022-0bfe-4f4c-95ed-a6ed44cf29bd",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHSO-RT",
    "id": "12be0228-c23c-4232-9770-7cc97817714c",
    "attributes": {
      "defaultSKU": "VDHSO-RT-RG-8801"
    },
    "parent": "f88ca0e7-860c-433f-ae9e-e3721761cfdf",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHSO-RG",
    "id": "2525c26a-31be-4f33-9996-a2e6791e7323",
    "attributes": {
      "defaultSKU": "VDHSO-RG-RC-8801"
    },
    "parent": "1e571359-878a-496f-8c32-A1f975cc55ad",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHST-CR",
    "id": "72d1b557-cd48-4118-909d-3102c305fe85",
    "attributes": {
      "defaultSKU": "VDHST-CR-T0-CC-8801"
    },
    "parent": "5eed4623-27eb-4401-aea8-55967786dfbc",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHST-RT",
    "id": "57b2a287-f6e8-4045-ba4d-38c7acda3173",
    "attributes": {
      "defaultSKU": "VDHST-RT-T0-RG-8801"
    },
    "parent": "ab5cad2b-4c4c-4d28-bf94-0e536d66eb18",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHST-RG",
    "id": "44f9bfdd-3b35-4b51-9c6f-6f9cc24a27d5",
    "attributes": {
      "defaultSKU": "VDHST-RG-T0-RC-8801"
    },
    "parent": "9bf3aded-4fd5-4c04-9951-cb49cfd2df7c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Standard Back Chair",
    "id": "df6ec1bf-a8da-4c6d-b056-92f0744ff2da",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-reg-chair.png"
    },
    "parent": "a9d84a72-7146-42dd-85ef-e0f728ac973d",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "a673ff51-a42a-4393-8a54-1b4b67ee9a28",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "med-chair.png"
    },
    "parent": "a9d84a72-7146-42dd-85ef-e0f728ac973d",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "3693ad2c-8198-46f8-b5ff-bf9a120fd513",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-stool.png"
    },
    "parent": "a9d84a72-7146-42dd-85ef-e0f728ac973d",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Stool With Back",
    "id": "de6114e3-8c63-47e3-9679-063588c9d03c",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-swb.png"
    },
    "parent": "a9d84a72-7146-42dd-85ef-e0f728ac973d",
    "index": 3,
    "type": "image-question"
  },
  {
    "name": "Standard Back Chair",
    "id": "7434f4ae-53ce-45df-81be-538b85865032",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-reg-chair.png"
    },
    "parent": "5bf653c4-9bcb-42e1-9074-d48b1dcaa1af",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "4f9cf9e4-616c-4afa-8266-349ac61432e9",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "med-chair.png"
    },
    "parent": "5bf653c4-9bcb-42e1-9074-d48b1dcaa1af",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "b0f5a925-6161-427e-8aa0-433329aa4e68",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-stool.png"
    },
    "parent": "5bf653c4-9bcb-42e1-9074-d48b1dcaa1af",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Stool With Back",
    "id": "60586045-90dd-4753-932d-152462f69f72",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "vinyl-swb.png"
    },
    "parent": "5bf653c4-9bcb-42e1-9074-d48b1dcaa1af",
    "index": 3,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "98c77e3f-4d2c-4740-a883-1d8505bcee06",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "df6ec1bf-a8da-4c6d-b056-92f0744ff2da",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "775692e9-7e3b-4af4-9cd4-268797add923",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "df6ec1bf-a8da-4c6d-b056-92f0744ff2da",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "7e73eaa7-7767-4724-a634-6e4dbd581351",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "df6ec1bf-a8da-4c6d-b056-92f0744ff2da",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "a62e6577-4ca1-481e-A165-65341c98992e",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "a673ff51-a42a-4393-8a54-1b4b67ee9a28",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "ac5d9b9f-3cad-4641-89fd-52016b9b1b54",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "a673ff51-a42a-4393-8a54-1b4b67ee9a28",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "2f06aab3-98e5-4ce1-9539-9fb0fa3bed7a",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "a673ff51-a42a-4393-8a54-1b4b67ee9a28",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "d038159d-9293-43c3-910e-d187bb1ab4e2",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "3693ad2c-8198-46f8-b5ff-bf9a120fd513",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "ad54799e-8071-4367-a5c1-b90866813f1c",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "3693ad2c-8198-46f8-b5ff-bf9a120fd513",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "2a774186-47eb-43e5-bcc0-de06034ebd36",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "3693ad2c-8198-46f8-b5ff-bf9a120fd513",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "b3c6ffa5-e389-41de-83a9-cdc6c7453cf5",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "de6114e3-8c63-47e3-9679-063588c9d03c",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "79a91269-8ecd-4990-bced-1a3805778367",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "de6114e3-8c63-47e3-9679-063588c9d03c",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "a87bd93b-8579-4edf-a7a0-f7b0d4dd69e9",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "de6114e3-8c63-47e3-9679-063588c9d03c",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "VMBCH-CR",
    "id": "3a51062a-bf15-4e02-83a3-1c4d3ca4a1a4",
    "attributes": {
      "defaultSKU": "VMBCH-CR-T0-A1-CF-CC-8801"
    },
    "parent": "98c77e3f-4d2c-4740-a883-1d8505bcee06",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBCH-RT",
    "id": "6739e0c6-3ce4-44e6-960e-899c4c954688",
    "attributes": {
      "defaultSKU": "VMBCH-RT-T0-A1-RG-8801"
    },
    "parent": "775692e9-7e3b-4af4-9cd4-268797add923",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBCH-RG",
    "id": "4c532f1d-6278-4035-983b-278e0246eb91",
    "attributes": {
      "defaultSKU": "VMBCH-RG-T0-A1-CF-RC-8801"
    },
    "parent": "7e73eaa7-7767-4724-a634-6e4dbd581351",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBCH-MB-CR",
    "id": "ae62ad70-f41f-4db3-9e04-e95fa780b8e6",
    "attributes": {
      "defaultSKU": "VMBCH-MB-CR-T0-A1-CF-CC-8801"
    },
    "parent": "a62e6577-4ca1-481e-A165-65341c98992e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBCH-MB-RT",
    "id": "ab7ad495-eaa8-49f5-8c2a-476102d9c2c1",
    "attributes": {
      "defaultSKU": "VMBCH-MB-RT-T0-A1-RG-8801"
    },
    "parent": "ac5d9b9f-3cad-4641-89fd-52016b9b1b54",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBCH-MB-RG",
    "id": "f8fa7141-e4aa-4970-b588-74744f3dafa6",
    "attributes": {
      "defaultSKU": "VMBCH-MB-RG-T0-A1-CF-RC-8801"
    },
    "parent": "2f06aab3-98e5-4ce1-9539-9fb0fa3bed7a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBSO-CR",
    "id": "f04ebd8a-34cc-41ab-b0d5-271376f50207",
    "attributes": {
      "defaultSKU": "VMBSO-CR-CF-CC-8801"
    },
    "parent": "d038159d-9293-43c3-910e-d187bb1ab4e2",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBSO-RT",
    "id": "79c70c7c-b1ba-4d47-adc7-206c5987b6c7",
    "attributes": {
      "defaultSKU": "VMBSO-RT-RG-8801"
    },
    "parent": "ad54799e-8071-4367-a5c1-b90866813f1c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBSO-RG",
    "id": "3f2f0bf7-0cf8-44fe-aa77-ffa9270b182b",
    "attributes": {
      "defaultSKU": "VMBSO-RG-CF-RC-8801"
    },
    "parent": "2a774186-47eb-43e5-bcc0-de06034ebd36",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBST-CR",
    "id": "06cf4c71-834d-4521-acb1-a910da02b77f",
    "attributes": {
      "defaultSKU": "VMBST-CR-T0-CF-CC-8801"
    },
    "parent": "b3c6ffa5-e389-41de-83a9-cdc6c7453cf5",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBST-RT",
    "id": "6ef91af6-575f-4e6a-9787-e459f7361620",
    "attributes": {
      "defaultSKU": "VMBST-RT-T0-RG-8801"
    },
    "parent": "79a91269-8ecd-4990-bced-1a3805778367",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBST-RG",
    "id": "cc7337be-10fd-4b73-85eb-f00537b1efbd",
    "attributes": {
      "defaultSKU": "VMBST-RG-T0-CF-RC-8801"
    },
    "parent": "a87bd93b-8579-4edf-a7a0-f7b0d4dd69e9",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Chrome Base",
    "id": "a7da39af-2802-4a7d-bb88-6c83db1112b6",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "7434f4ae-53ce-45df-81be-538b85865032",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "37f0fe0c-8dcd-4ffe-bc1c-25b1559a31d8",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "7434f4ae-53ce-45df-81be-538b85865032",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "a32bac8f-ad05-437d-8f91-10b3527ba6a9",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "4f9cf9e4-616c-4afa-8266-349ac61432e9",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "e46046e1-0df7-4af6-a511-95d4c01bb16f",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "4f9cf9e4-616c-4afa-8266-349ac61432e9",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "85d82865-49b5-4c57-a4d0-135fe707e4aa",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "b0f5a925-6161-427e-8aa0-433329aa4e68",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "8ccf85bd-db37-4c66-8f79-3d93c2745192",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "b0f5a925-6161-427e-8aa0-433329aa4e68",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "fa8f63e5-4a38-45f2-8cd9-c6f3094724b2",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "60586045-90dd-4753-932d-152462f69f72",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "1768bc97-4773-49be-b385-03759c048499",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "60586045-90dd-4753-932d-152462f69f72",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "VHBCH-CR",
    "id": "eee24133-f3d1-4fb7-8e7f-610f6c020b3e",
    "attributes": {
      "defaultSKU": "VHBCH-CR-T0-A1-CF-CC-8801"
    },
    "parent": "a7da39af-2802-4a7d-bb88-6c83db1112b6",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBCH-RG",
    "id": "d407981c-defa-4b1f-aa0f-15499ef3f738",
    "attributes": {
      "defaultSKU": "VHBCH-RG-T0-A1-CF-RC-8801"
    },
    "parent": "37f0fe0c-8dcd-4ffe-bc1c-25b1559a31d8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBCH-MB-CR",
    "id": "61a3640c-75f8-4872-A122-2583f1de94b1",
    "attributes": {
      "defaultSKU": "VHBCH-MB-CR-T0-A1-CF-CC-8801"
    },
    "parent": "a32bac8f-ad05-437d-8f91-10b3527ba6a9",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBCH-MB-RG",
    "id": "39f909c3-b940-4368-b119-9a088af776ea",
    "attributes": {
      "defaultSKU": "VHBCH-MB-RG-T0-A1-CF-RC-8801"
    },
    "parent": "e46046e1-0df7-4af6-a511-95d4c01bb16f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBSO-CR",
    "id": "8024209a-4c99-432f-bbae-0b850b6a28cd",
    "attributes": {
      "defaultSKU": "VHBSO-CR-CF-CC-8801"
    },
    "parent": "85d82865-49b5-4c57-a4d0-135fe707e4aa",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBSO-RG",
    "id": "62b91688-adef-419e-854d-1df96fe80c10",
    "attributes": {
      "defaultSKU": "VHBSO-RG-CF-RC-8801"
    },
    "parent": "8ccf85bd-db37-4c66-8f79-3d93c2745192",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBST-CR",
    "id": "a91d6382-f595-4c76-b0fc-b588f5275285",
    "attributes": {
      "defaultSKU": "VHBST-CR-T0-CF-CC-8801"
    },
    "parent": "fa8f63e5-4a38-45f2-8cd9-c6f3094724b2",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VHBST-RG",
    "id": "bbbeb1b1-c607-436f-9366-0d755e1332e6",
    "attributes": {
      "defaultSKU": "VHBST-RG-T0-CF-RC-8801"
    },
    "parent": "1768bc97-4773-49be-b385-03759c048499",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "bfdf937a-0908-44d2-869f-9b688efd5c9c",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "b6dd003f-fb43-45ab-9dfc-8acbc72e1e7f",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "9af4fe19-ba66-4fd0-8192-be5fa3fffe52",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "b6dd003f-fb43-45ab-9dfc-8acbc72e1e7f",
    "index": 2
  },
  {
    "name": "Standard Back Chair",
    "id": "4eab523c-d4c7-4cc5-9ace-c49d0da70d27",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric.png"
    },
    "parent": "bfdf937a-0908-44d2-869f-9b688efd5c9c",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Standard Back Chair",
    "id": "cf0f29a3-c243-47e5-923f-dff24249088d",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric.png"
    },
    "parent": "9af4fe19-ba66-4fd0-8192-be5fa3fffe52",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "cfc9a929-abdf-4b77-ba01-18162ee3b122",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-med-chair.png"
    },
    "parent": "5bfc141f-c6ef-4f80-ad04-19e6ad25cb6a",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "22a865a6-3bd4-4405-afc4-b932c5cc7021",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-stool.png"
    },
    "parent": "5bfc141f-c6ef-4f80-ad04-19e6ad25cb6a",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Stool With Back",
    "id": "21cab4f6-c00b-431f-a72e-973f974d65aa",
    "attributes": {
      "image": "fabric-swb.png",
      "question": "What type of base do you prefer?"
    },
    "parent": "5bfc141f-c6ef-4f80-ad04-19e6ad25cb6a",
    "index": 3,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "ce8e842a-41ea-4ce7-A1a2-5e3eba35265c",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-med-chair.png"
    },
    "parent": "bfdf937a-0908-44d2-869f-9b688efd5c9c",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "72ef05ba-3dc5-46d6-a540-201ccdb635a8",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-stool.png"
    },
    "parent": "bfdf937a-0908-44d2-869f-9b688efd5c9c",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Stool With Back",
    "id": "22771503-5c48-4fe5-a2f8-4722b737f014",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-swb.png"
    },
    "parent": "bfdf937a-0908-44d2-869f-9b688efd5c9c",
    "index": 3,
    "type": "image-question"
  },
  {
    "name": "Large Back Chair",
    "id": "6891032e-2d33-48a4-8d5b-ff47750ded12",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-med-chair.png"
    },
    "parent": "9af4fe19-ba66-4fd0-8192-be5fa3fffe52",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Stool",
    "id": "da90c15f-49ee-4139-88c3-1af450b48000",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-stool.png"
    },
    "parent": "9af4fe19-ba66-4fd0-8192-be5fa3fffe52",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Stool With Back",
    "id": "365ea4c6-2c78-44b3-80ff-66a2695ae40b",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "fabric-swb.png"
    },
    "parent": "9af4fe19-ba66-4fd0-8192-be5fa3fffe52",
    "index": 3,
    "type": "image-question"
  },
  {
    "name": "Round Tube Base",
    "id": "ce50f2b6-2f91-4290-9df8-05144cb731c1",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "842c5498-5909-4695-9719-f57b14730b93",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "d60dbe61-b805-4c3e-9390-7c8b4a3f856e",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "842c5498-5909-4695-9719-f57b14730b93",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "4cd6e10b-4863-4876-a98b-fc2965a5ec7c",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "cfc9a929-abdf-4b77-ba01-18162ee3b122",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "c19fd12b-1ed8-4e30-93cc-f62fe8be92ad",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "cfc9a929-abdf-4b77-ba01-18162ee3b122",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "12a4c1f5-f270-45b8-bd82-73ca17cb6b6d",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "cfc9a929-abdf-4b77-ba01-18162ee3b122",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "6144e154-dee2-4f0f-935d-ba346c6bc043",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "22a865a6-3bd4-4405-afc4-b932c5cc7021",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "51a448e7-43b0-44c7-a550-3f01fb8244a9",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "22a865a6-3bd4-4405-afc4-b932c5cc7021",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "44949eaa-38f9-4f31-9109-1759c07eacfc",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "22a865a6-3bd4-4405-afc4-b932c5cc7021",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "0cc652c9-112c-41ac-b90a-1c4aedeb5f56",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "21cab4f6-c00b-431f-a72e-973f974d65aa",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "48c4788c-b660-499e-9591-ebb74ced49ad",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "21cab4f6-c00b-431f-a72e-973f974d65aa",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "0e2cd566-42fe-4b0c-ba8e-73433307fec0",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "21cab4f6-c00b-431f-a72e-973f974d65aa",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "FDHCH-MB-CR",
    "id": "970c3c27-2823-4665-aa22-a77afbd612ee",
    "attributes": {
      "defaultSKU": "FDHCH-MB-CR-T0-A1-CC-F44"
    },
    "parent": "4cd6e10b-4863-4876-a98b-fc2965a5ec7c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHCH-MB-RT",
    "id": "501f9ba9-a4db-498b-8d96-884c3e5d2762",
    "attributes": {
      "defaultSKU": "FDHCH-MB-RT-T0-A1-RG-F44"
    },
    "parent": "c19fd12b-1ed8-4e30-93cc-f62fe8be92ad",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHCH-MB-RG",
    "id": "bf24b4ab-0e54-4e46-89f8-7b34d304418d",
    "attributes": {
      "defaultSKU": "FDHCH-MB-RG-T0-A1-RC-F44"
    },
    "parent": "12a4c1f5-f270-45b8-bd82-73ca17cb6b6d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHSO-CR",
    "id": "5e94f727-d5a6-453e-a85c-084b110484d6",
    "attributes": {
      "defaultSKU": "FDHSO-CR-CC-F44"
    },
    "parent": "6144e154-dee2-4f0f-935d-ba346c6bc043",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHSO-RT",
    "id": "4f2724b3-0833-482c-a116-576773f78fb5",
    "attributes": {
      "defaultSKU": "FDHSO-RT-RG-F44"
    },
    "parent": "51a448e7-43b0-44c7-a550-3f01fb8244a9",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHSO-RG",
    "id": "e82f8855-7e3b-4f6d-b7a7-9eba656a22e0",
    "attributes": {
      "defaultSKU": "FDHSO-RG-RC-F44"
    },
    "parent": "44949eaa-38f9-4f31-9109-1759c07eacfc",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHST-CR",
    "id": "bab09671-c8f9-4d32-87a8-f730d914827b",
    "attributes": {
      "defaultSKU": "FDHST-CR-T0-CC-F44"
    },
    "parent": "0cc652c9-112c-41ac-b90a-1c4aedeb5f56",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHST-RT",
    "id": "244109ff-47ac-4510-97f6-732dab5d4968",
    "attributes": {
      "defaultSKU": "FDHST-RT-T0-RG-F44"
    },
    "parent": "48c4788c-b660-499e-9591-ebb74ced49ad",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHST-RG",
    "id": "85885eab-8bf6-4fbe-acb0-4a5b95e04b54",
    "attributes": {
      "defaultSKU": "FDHST-RG-T0-RC-F44"
    },
    "parent": "0e2cd566-42fe-4b0c-ba8e-73433307fec0",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Chrome Base",
    "id": "3a2921ca-bc6c-4462-ada1-7f8afb1a0d55",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "4eab523c-d4c7-4cc5-9ace-c49d0da70d27",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "b91daafb-f7d7-42fd-bb58-e0bfbc45e02c",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "4eab523c-d4c7-4cc5-9ace-c49d0da70d27",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "8ca613fe-4ef1-40fd-9578-39ad571fed55",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "4eab523c-d4c7-4cc5-9ace-c49d0da70d27",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "83356a9c-4ba8-415a-97ef-9fc063154dae",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "ce8e842a-41ea-4ce7-A1a2-5e3eba35265c",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "38155038-c262-43b2-9a05-fd3bdd1541b6",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "ce8e842a-41ea-4ce7-A1a2-5e3eba35265c",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "6614375d-75f4-4f59-a553-5278121cff95",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "ce8e842a-41ea-4ce7-A1a2-5e3eba35265c",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "6b8f8d51-58e7-4c3c-ae08-3c6dbdffd485",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "72ef05ba-3dc5-46d6-a540-201ccdb635a8",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "c9e478e3-b787-4475-8a4d-ac62c33b3c3d",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "72ef05ba-3dc5-46d6-a540-201ccdb635a8",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "048561bd-fcf6-43ab-ba15-6df75771913e",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "72ef05ba-3dc5-46d6-a540-201ccdb635a8",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "3ae303ae-a669-40ed-9814-f0f6672a610f",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "22771503-5c48-4fe5-a2f8-4722b737f014",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "f7b71a3f-193c-41f5-A1e6-295179c00e39",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "22771503-5c48-4fe5-a2f8-4722b737f014",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "23d261a2-b701-4ce3-bd2d-71f43e368d66",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "22771503-5c48-4fe5-a2f8-4722b737f014",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "23f9051f-4f7e-427b-b13d-82285a091877",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "cf0f29a3-c243-47e5-923f-dff24249088d",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "a34c0ea8-7192-467e-a2ce-de722b9458ca",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "cf0f29a3-c243-47e5-923f-dff24249088d",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "2536ff1e-fd3d-4204-99be-A173a299288c",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "6891032e-2d33-48a4-8d5b-ff47750ded12",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "3372055e-4bc4-4d11-a2df-7d690b4384c9",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "6891032e-2d33-48a4-8d5b-ff47750ded12",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "eae10767-9177-4ab7-b33e-9b9b17882ebf",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "da90c15f-49ee-4139-88c3-1af450b48000",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "c5e97a6d-A1cb-4d6f-810c-9e618e492720",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "da90c15f-49ee-4139-88c3-1af450b48000",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "eaa6c89f-e3f0-4fdc-b74a-1320f7fcef69",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "365ea4c6-2c78-44b3-80ff-66a2695ae40b",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "966d34cb-c559-4a15-9fe1-1d30e0dc4a07",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "365ea4c6-2c78-44b3-80ff-66a2695ae40b",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "FMBCH-CR",
    "id": "0ea08225-2d5d-4b43-be92-7c7e03d8d533",
    "attributes": {
      "defaultSKU": "FMBCH-CR-T0-A1-CF-CC-F44"
    },
    "parent": "3a2921ca-bc6c-4462-ada1-7f8afb1a0d55",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBCH-RT",
    "id": "22632314-3782-4ee0-9f6e-62197e8ba8f4",
    "attributes": {
      "defaultSKU": "FMBCH-RT-T0-A1-RG-F44"
    },
    "parent": "b91daafb-f7d7-42fd-bb58-e0bfbc45e02c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBCH-RG",
    "id": "7c95758b-aee3-4c9d-9b61-21493ea07f4c",
    "attributes": {
      "defaultSKU": "FMBCH-RG-T0-A1-CF-RC-F44"
    },
    "parent": "8ca613fe-4ef1-40fd-9578-39ad571fed55",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBCH-MB-CR",
    "id": "53e4e6a2-6c97-4c46-baeb-89eeab00c512",
    "attributes": {
      "defaultSKU": "FMBCH-MB-CR-T0-A1-CF-CC-F44"
    },
    "parent": "83356a9c-4ba8-415a-97ef-9fc063154dae",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBCH-MB-RT",
    "id": "1cdae755-4bc9-4d41-a954-c6e0fdd412aa",
    "attributes": {
      "defaultSKU": "FMBCH-MB-RT-T0-A1-RG-F44"
    },
    "parent": "38155038-c262-43b2-9a05-fd3bdd1541b6",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBCH-MB-RG",
    "id": "c6a8751a-6df6-4b22-baae-0e3753a830be",
    "attributes": {
      "defaultSKU": "FMBCH-MB-RG-T0-A1-CF-RC-F44"
    },
    "parent": "6614375d-75f4-4f59-a553-5278121cff95",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBSO-CR",
    "id": "65f0ec51-c68a-433f-8d90-91b841ed9afb",
    "attributes": {
      "defaultSKU": "FMBSO-CR-CF-CC-F44"
    },
    "parent": "6b8f8d51-58e7-4c3c-ae08-3c6dbdffd485",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBSO-RT",
    "id": "19236ce5-1c84-4e34-b63a-8785b7af386c",
    "attributes": {
      "defaultSKU": "FMBSO-RT-RG-F44"
    },
    "parent": "c9e478e3-b787-4475-8a4d-ac62c33b3c3d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBSO-RG",
    "id": "06353364-e149-41a9-90c8-7713824629d7",
    "attributes": {
      "defaultSKU": "FMBSO-RG-CF-RC-F44"
    },
    "parent": "048561bd-fcf6-43ab-ba15-6df75771913e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBST-CR",
    "id": "6b8dcf54-2c21-42bb-9d30-e97bc6582ca0",
    "attributes": {
      "defaultSKU": "FMBST-CR-T0-CF-CC-F44"
    },
    "parent": "3ae303ae-a669-40ed-9814-f0f6672a610f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBST-RT",
    "id": "4b325974-73c4-4e31-9d77-e6e2dbf6c73a",
    "attributes": {
      "defaultSKU": "FMBST-RT-T0-RG-F44"
    },
    "parent": "f7b71a3f-193c-41f5-A1e6-295179c00e39",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FMBST-RG",
    "id": "77775abb-d3e2-41f4-abcc-129ca94ff5da",
    "attributes": {
      "defaultSKU": "FMBST-RG-T0-CF-RC-F44"
    },
    "parent": "23d261a2-b701-4ce3-bd2d-71f43e368d66",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBCH-CR",
    "id": "c74b5f89-0e53-4608-aeae-a23f1a8e0bd2",
    "attributes": {
      "defaultSKU": "FHBCH-CR-T0-A1-CF-CC-F44"
    },
    "parent": "23f9051f-4f7e-427b-b13d-82285a091877",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBCH-RG",
    "id": "41b873c9-9a5d-4cd9-abef-bae3ca50f9a7",
    "attributes": {
      "defaultSKU": "FHBCH-RG-T0-A1-CF-RC-F44"
    },
    "parent": "a34c0ea8-7192-467e-a2ce-de722b9458ca",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBCH-MB-CR",
    "id": "a535206c-0b96-4890-9cd5-f8a624680d41",
    "attributes": {
      "defaultSKU": "FHBCH-MB-CR-T0-A1-CF-CC-F44"
    },
    "parent": "2536ff1e-fd3d-4204-99be-A173a299288c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBCH-MB-RG",
    "id": "63387a58-1d8b-40ce-a615-99b4421c50d1",
    "attributes": {
      "defaultSKU": "FHBCH-MB-RG-T0-A1-CF-RC-F44"
    },
    "parent": "3372055e-4bc4-4d11-a2df-7d690b4384c9",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBSO-CR",
    "id": "6da31dbe-c044-4978-b9f6-8854ff4b79d7",
    "attributes": {
      "defaultSKU": "FHBSO-CR-CF-CC-F44"
    },
    "parent": "eae10767-9177-4ab7-b33e-9b9b17882ebf",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBSO-RG",
    "id": "dfde6780-dc82-45b3-816d-48b3e237c367",
    "attributes": {
      "defaultSKU": "FHBSO-RG-CF-RC-F44"
    },
    "parent": "c5e97a6d-A1cb-4d6f-810c-9e618e492720",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBST-CR",
    "id": "bfa0d22f-755a-485f-8930-d889e9324c55",
    "attributes": {
      "defaultSKU": "FHBST-CR-T0-CF-CC-F44"
    },
    "parent": "eaa6c89f-e3f0-4fdc-b74a-1320f7fcef69",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FHBST-RG",
    "id": "818b66cd-0d83-4923-a574-f30113ef1d80",
    "attributes": {
      "defaultSKU": "FHBST-RG-T0-CF-RC-F44"
    },
    "parent": "966d34cb-c559-4a15-9fe1-1d30e0dc4a07",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHCH-RG",
    "id": "7365712a-58e6-461d-931e-72e7e7955ecd",
    "attributes": {
      "defaultSKU": "FDHCH-RG-T0-A1-RC-F44"
    },
    "parent": "d60dbe61-b805-4c3e-9390-7c8b4a3f856e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHCH-RT",
    "id": "fe664625-57f2-4f62-960e-656e30696eb6",
    "attributes": {
      "defaultSKU": "FDHCH-RT-T0-A1-RG-F44"
    },
    "parent": "ce50f2b6-2f91-4290-9df8-05144cb731c1",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "FDHCH-CR",
    "id": "801be1ed-e35e-41ac-9c8f-a1a4c2206daf",
    "attributes": {
      "defaultSKU": "FDHCH-CR-T0-A1-CC-F44"
    },
    "parent": "2870ab33-2c52-4d84-8d39-8a8fc07ee79c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Guest",
    "id": "6db9fcd8-ea71-48f5-8eee-0f7166be5d8a",
    "attributes": {
      "question": "Choose your material"
    },
    "parent": "3",
    "index": 1
  },
  {
    "name": "Mesh",
    "id": "459ac3c3-2da7-4de1-a2a3-20e50c3471f1",
    "attributes": {
      "question": "What type of seating do you prefer?",
      "image": "mesh.png"
    },
    "parent": "6db9fcd8-ea71-48f5-8eee-0f7166be5d8a",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Fabric",
    "id": "fba4abd5-319f-44b6-8290-8291f525369f",
    "attributes": {
      "image": "fabric.png"
    },
    "parent": "6db9fcd8-ea71-48f5-8eee-0f7166be5d8a",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Oxford",
    "id": "8f30d05f-8308-402f-b9e7-1661287b3d09",
    "attributes": {
      "image": "oxford.png"
    },
    "parent": "459ac3c3-2da7-4de1-a2a3-20e50c3471f1",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Windrowe",
    "id": "13fa897f-559f-43be-9c7d-e90fe53e4b1c",
    "attributes": {
      "image": "windrowe.png"
    },
    "parent": "459ac3c3-2da7-4de1-a2a3-20e50c3471f1",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "GMOD-MDHCH-RG",
    "id": "c1a4f5ba-bcc3-4d2a-a64c-bb14a892e22e",
    "attributes": {
      "defaultSKU": "GMOD-MDHCH-RG-A1-RG"
    },
    "parent": "8f30d05f-8308-402f-b9e7-1661287b3d09",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "GEXE-MDHCH-RG",
    "id": "92516450-a87c-4619-8dc7-71e35aa0bddc",
    "attributes": {
      "defaultSKU": "GEXE-MDHCH-RG-H0-A1-RG"
    },
    "parent": "13fa897f-559f-43be-9c7d-e90fe53e4b1c",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "GFDHCH-RG",
    "id": "eec24dd7-6983-4985-899f-24e65e3d0942",
    "attributes": {
      "defaultSKU": "GFDHCH-RG-RG"
    },
    "parent": "fba4abd5-319f-44b6-8290-8291f525369f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Speciality",
    "type": "image-question",
    "id": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "attributes": {
      "image": "speciality.png",
      "question": "Which type of seating do you prefer?"
    },
    "parent": "0",
    "index": 3
  },
  {
    "name": "Nylon Sit Stand",
    "id": "2e834f4c-7c14-416a-bdd8-b240f9976176",
    "attributes": {
      "image": "sitstandRG.png"
    },
    "parent": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Sit Stand",
    "id": "02ba9420-f61d-4880-a9db-af11f0e86a86",
    "attributes": {
      "image": "sitstandCR.png"
    },
    "parent": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Desk Height Mini Stool",
    "id": "0e356aa8-cca0-4ff8-8492-6f2c3155063d",
    "attributes": {
      "image": "miniDHstool.png"
    },
    "parent": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Medium Bench Mini Stool",
    "id": "60c88a05-dc80-4ab9-ab4e-ac639c5773fb",
    "attributes": {
      "image": "miniMBstool.png"
    },
    "parent": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "index": 3,
    "type": "title-&-image"
  },
  {
    "name": "Screw Lift Stool",
    "id": "f29c6425-3a68-4b78-b9be-1f9870ef0c03",
    "attributes": {
      "image": "ministool.png"
    },
    "parent": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "index": 4,
    "type": "title-&-image"
  },
  {
    "name": "VSLMD-CR",
    "id": "ea232f26-c7a9-48df-9354-7f89ce8e71af",
    "attributes": {
      "defaultSKU": "VSLMD-CR-RC-8540"
    },
    "parent": "f29c6425-3a68-4b78-b9be-1f9870ef0c03",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VMBMS-RG",
    "id": "1401d55c-cfa0-4ab9-97f5-a4c1e86151f0",
    "attributes": {
      "defaultSKU": "VMBMS-RG-NF-RC-8540"
    },
    "parent": "60c88a05-dc80-4ab9-ab4e-ac639c5773fb",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "VDHMS-RG",
    "id": "1588cd19-6105-4a87-b066-03ff4340c3d7",
    "attributes": {
      "defaultSKU": "VDHMS-RG-RC-8540"
    },
    "parent": "0e356aa8-cca0-4ff8-8492-6f2c3155063d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PSTSS-CR",
    "id": "653a1cfe-5b4e-4c66-a7a7-3719aa5c960d",
    "attributes": {
      "defaultSKU": "PSTSS-CR-NF-RG"
    },
    "parent": "02ba9420-f61d-4880-a9db-af11f0e86a86",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PSTSS-RG",
    "id": "6698935c-29f6-4f15-899a-87a174a7e16f",
    "attributes": {
      "defaultSKU": "PSTSS-RG-NF-RG"
    },
    "parent": "2e834f4c-7c14-416a-bdd8-b240f9976176",
    "index": 0,
    "type": "leaf"
  },
  {
    "type": "image-question",
    "name": "Controlled Environment (ESD or Clean Room)",
    "id": "2d3fff2b-b460-4b99-b157-b0c17fce0fe5",
    "attributes": {
      "image": "poly.png",
      "question": "What type of controlled environment do you have?"
    },
    "parent": "0",
    "index": 1
  },
  {
    "name": "ESD (Electrostatic Discharge)",
    "id": "7ff6bf4a-a74b-4522-808e-307f49c5a004",
    "attributes": {
      "question": "Choose your material"
    },
    "parent": "2d3fff2b-b460-4b99-b157-b0c17fce0fe5",
    "index": 0
  },
  {
    "name": "Vinyl",
    "id": "00ba6586-ee05-46fd-b52c-c2aa02c29db6",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "vinyl.png"
    },
    "parent": "7ff6bf4a-a74b-4522-808e-307f49c5a004",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Fabric",
    "id": "7605bc8c-0f25-4a32-bd71-5b8873a318c4",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "fabric.png"
    },
    "parent": "7ff6bf4a-a74b-4522-808e-307f49c5a004",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "6524f203-9720-4a8a-835c-4aa28fd03cbc",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "00ba6586-ee05-46fd-b52c-c2aa02c29db6",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "9e7d4d54-4504-4754-87b1-ca0979e29d0f",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "00ba6586-ee05-46fd-b52c-c2aa02c29db6",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "97227356-d980-4a4a-ae3d-eaa54025cd17",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "00ba6586-ee05-46fd-b52c-c2aa02c29db6",
    "index": 2
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "f300120b-67fb-49f5-A1ad-e2a0b96095e4",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "7605bc8c-0f25-4a32-bd71-5b8873a318c4",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "2a189a67-2f14-4864-9438-9bf3f299c831",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "7605bc8c-0f25-4a32-bd71-5b8873a318c4",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "3bb36f17-344b-4300-bb16-79c5bdbfa139",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "7605bc8c-0f25-4a32-bd71-5b8873a318c4",
    "index": 2
  },
  {
    "name": "Standard Back Chair",
    "id": "817ee2b4-d01b-4182-b723-99619105df90",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "6524f203-9720-4a8a-835c-4aa28fd03cbc",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "354dd126-595f-446e-b11a-266c4f536ee4",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "6524f203-9720-4a8a-835c-4aa28fd03cbc",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "3c1e4095-868b-45a1-a2be-855a405c80c8",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "9e7d4d54-4504-4754-87b1-ca0979e29d0f",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "bd5325ee-2de9-4025-9bd8-a4b82f6561bf",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "9e7d4d54-4504-4754-87b1-ca0979e29d0f",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "f94e3aea-6e85-4d83-bc98-e2b2c8cca614",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "97227356-d980-4a4a-ae3d-eaa54025cd17",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "f2e16290-16af-4316-8f93-c7c28d32f985",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "97227356-d980-4a4a-ae3d-eaa54025cd17",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "48ebb2d4-39c8-46cb-ab79-a2cdd5f803cd",
    "attributes": {
      "image": "fabric.png"
    },
    "parent": "f300120b-67fb-49f5-A1ad-e2a0b96095e4",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "277aea7b-f0a8-497d-9d4d-36830236c2a9",
    "attributes": {
      "image": "fabric-med-chair.png"
    },
    "parent": "f300120b-67fb-49f5-A1ad-e2a0b96095e4",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "ab12408c-998e-42aa-bcc4-f985d3a885e6",
    "attributes": {
      "image": "fabric.png"
    },
    "parent": "2a189a67-2f14-4864-9438-9bf3f299c831",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "6d9da7ab-da02-498c-864a-8307c150b317",
    "attributes": {
      "image": "fabric-med-chair.png"
    },
    "parent": "2a189a67-2f14-4864-9438-9bf3f299c831",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "69aeaaea-158f-4381-8f16-03b58099f496",
    "attributes": {
      "image": "fabric.png"
    },
    "parent": "3bb36f17-344b-4300-bb16-79c5bdbfa139",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "8b666e08-4e15-4888-9d54-aff2041f904e",
    "attributes": {
      "image": "fabric-med-chair.png"
    },
    "parent": "3bb36f17-344b-4300-bb16-79c5bdbfa139",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "ESD-VDHCH-CR",
    "id": "8e14496c-217f-4952-b55d-759fa6067564",
    "attributes": {
      "defaultSKU": "ESD-VDHCH-CR-T0-A1-EC-ESDBLU"
    },
    "parent": "817ee2b4-d01b-4182-b723-99619105df90",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-VDHCH-MB-CR",
    "id": "2b96e3e8-7159-46cf-9361-37ea21ee17cc",
    "attributes": {
      "defaultSKU": "ESD-VDHCH-MB-CR-T0-A1-EC-ESDBLU"
    },
    "parent": "354dd126-595f-446e-b11a-266c4f536ee4",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-VMBCH-CR",
    "id": "fd019a8f-b292-40d5-b7a8-ed8a47031551",
    "attributes": {
      "defaultSKU": "ESD-VMBCH-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "3c1e4095-868b-45a1-a2be-855a405c80c8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-VMBCH-MB-CR",
    "id": "70d93913-a1ff-49d4-bc15-f93ebfdc82f0",
    "attributes": {
      "defaultSKU": "ESD-VMBCH-MB-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "bd5325ee-2de9-4025-9bd8-a4b82f6561bf",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-VHBCH-CR",
    "id": "7707214a-941e-4a34-9813-14b8644341cf",
    "attributes": {
      "defaultSKU": "ESD-VHBCH-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "f94e3aea-6e85-4d83-bc98-e2b2c8cca614",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-VHBCH-MB-CR",
    "id": "5d4b17cd-3e64-4d96-bc7b-dc718c1578b7",
    "attributes": {
      "defaultSKU": "ESD-VHBCH-MB-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "f2e16290-16af-4316-8f93-c7c28d32f985",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-FDHCH-CR",
    "id": "3e7cd368-0877-4d26-936d-0d5efaa14a58",
    "attributes": {
      "defaultSKU": "ESD-FDHCH-CR-T0-A1-EC-ESDBLU"
    },
    "parent": "48ebb2d4-39c8-46cb-ab79-a2cdd5f803cd",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-FDHCH-MB-CR",
    "id": "17dd8952-0b78-4186-8fb9-088f65417790",
    "attributes": {
      "defaultSKU": "ESD-FDHCH-MB-CR-T0-A1-EC-ESDBLU"
    },
    "parent": "277aea7b-f0a8-497d-9d4d-36830236c2a9",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-FMBCH-CR",
    "id": "4b0d0a3f-d194-4615-8b11-c3c91983e1af",
    "attributes": {
      "defaultSKU": "ESD-FMBCH-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "ab12408c-998e-42aa-bcc4-f985d3a885e6",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-FMBCH-MB-CR",
    "id": "0560534d-2481-4f79-9814-c30532fe3806",
    "attributes": {
      "defaultSKU": "ESD-FMBCH-MB-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "6d9da7ab-da02-498c-864a-8307c150b317",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-FHBCH-CR",
    "id": "3af5b2c5-1e40-4de2-9a92-993197432053",
    "attributes": {
      "defaultSKU": "ESD-FHBCH-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "69aeaaea-158f-4381-8f16-03b58099f496",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-FHBCH-MB-CR",
    "id": "f4c78691-f6ca-4032-aedc-a319797ae289",
    "attributes": {
      "defaultSKU": "ESD-FHBCH-MB-CR-T0-A1-CF-EC-ESDBLU"
    },
    "parent": "8b666e08-4e15-4888-9d54-aff2041f904e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Clean Room (Class 10 - ISO4)",
    "id": "9e98fdb3-8439-4b38-af22-09b59dced186",
    "attributes": {
      "question": "Choose your material"
    },
    "parent": "2d3fff2b-b460-4b99-b157-b0c17fce0fe5",
    "index": 1
  },
  {
    "name": "Polyurethane",
    "id": "0dad08ae-fbe9-4f9e-863d-c21e67f50dff",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "poly.png"
    },
    "parent": "9e98fdb3-8439-4b38-af22-09b59dced186",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Vinyl",
    "id": "000502a8-3183-4106-aaa4-4606483b4643",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "vinyl.png"
    },
    "parent": "9e98fdb3-8439-4b38-af22-09b59dced186",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "6defa171-8349-4350-b4eb-e569a499b8f9",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "0dad08ae-fbe9-4f9e-863d-c21e67f50dff",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "c8d95346-79ae-423b-b897-b04a05f83cda",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "0dad08ae-fbe9-4f9e-863d-c21e67f50dff",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "5a2ac805-dcf9-44c0-a78c-51415a8f52f5",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "0dad08ae-fbe9-4f9e-863d-c21e67f50dff",
    "index": 2
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "61c83495-bdca-4869-bde0-aebd852ae44e",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "000502a8-3183-4106-aaa4-4606483b4643",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "66150f19-48c9-4af8-8ea7-7b1b99af0661",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "000502a8-3183-4106-aaa4-4606483b4643",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "9ce52912-6fe2-4787-ad7a-175762e2283d",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "000502a8-3183-4106-aaa4-4606483b4643",
    "index": 2
  },
  {
    "name": "Standard Back Chair",
    "id": "5ba3babb-e468-446e-b66e-a3b2e85f96df",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "c8d95346-79ae-423b-b897-b04a05f83cda",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "cd32eecf-da2c-4e2c-920a-1c4986e3a40d",
    "attributes": {
      "image": "poly-med-chair.png"
    },
    "parent": "c8d95346-79ae-423b-b897-b04a05f83cda",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Stool",
    "id": "33bc4a10-0aca-4fa3-a589-86d8323bf1f7",
    "attributes": {
      "image": "poly-stool.png"
    },
    "parent": "c8d95346-79ae-423b-b897-b04a05f83cda",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "7e157a30-fbae-4142-83ba-8f035bde582b",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "5a2ac805-dcf9-44c0-a78c-51415a8f52f5",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "1fc98d06-99c1-4bc0-adbe-2c2d30022393",
    "attributes": {
      "image": "poly-med-chair.png"
    },
    "parent": "5a2ac805-dcf9-44c0-a78c-51415a8f52f5",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Stool",
    "id": "0517a343-c2e1-44b4-a150-5283b6569b4b",
    "attributes": {
      "image": "poly-stool.png"
    },
    "parent": "5a2ac805-dcf9-44c0-a78c-51415a8f52f5",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "ac1ee47d-c163-44eb-9123-8c4b2873403f",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "6defa171-8349-4350-b4eb-e569a499b8f9",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "3f07bd6c-7529-4cc6-aae3-7b8ddeda2f8d",
    "attributes": {
      "image": "poly-med-chair.png"
    },
    "parent": "6defa171-8349-4350-b4eb-e569a499b8f9",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Stool",
    "id": "402d90b8-4c2e-4a58-9923-44f25c00bbfc",
    "attributes": {
      "image": "poly-stool.png"
    },
    "parent": "6defa171-8349-4350-b4eb-e569a499b8f9",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "3ee13a9d-6699-4907-b389-6cd1b134999a",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "61c83495-bdca-4869-bde0-aebd852ae44e",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "19d3c99a-050f-46bf-826c-d61e20d1e751",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "61c83495-bdca-4869-bde0-aebd852ae44e",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "a8c4d40f-9336-4339-9632-f6509dfb7e38",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "66150f19-48c9-4af8-8ea7-7b1b99af0661",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "cc450298-755d-4d14-822b-b24edaa28813",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "66150f19-48c9-4af8-8ea7-7b1b99af0661",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "8bc6e882-ed96-4848-acae-b4800f10f114",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "9ce52912-6fe2-4787-ad7a-175762e2283d",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "b10cb49c-2665-4faa-b958-02caaab93276",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "9ce52912-6fe2-4787-ad7a-175762e2283d",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "CLR-VHBCH-MB-CR",
    "id": "f12eec9f-64d4-4946-8165-e150d69e4ad1",
    "attributes": {
      "defaultSKU": "CLR-VHBCH-MB-CR-CF-CC-8540"
    },
    "parent": "b10cb49c-2665-4faa-b958-02caaab93276",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-VHBCH-CR",
    "id": "ff5da2d4-a574-4ac6-853d-9aa2169d4402",
    "attributes": {
      "defaultSKU": "CLR-VHBCH-CR-CF-CC-8540"
    },
    "parent": "8bc6e882-ed96-4848-acae-b4800f10f114",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-VMBCH-MB-CR",
    "id": "f6c10409-10ff-4563-9123-b95a6d60aa44",
    "attributes": {
      "defaultSKU": "CLR-VMBCH-MB-CR-NF-CC-8540"
    },
    "parent": "cc450298-755d-4d14-822b-b24edaa28813",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-VMBCH-CR",
    "id": "62d9b8dc-9b23-4b81-8096-4a2c9f25a1cb",
    "attributes": {
      "defaultSKU": "CLR-VMBCH-CR-NF-CC-8540"
    },
    "parent": "a8c4d40f-9336-4339-9632-f6509dfb7e38",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-VDHCH-MB-CR",
    "id": "f5c17ce6-5d0a-4c35-a6b0-c16b9e0560e7",
    "attributes": {
      "defaultSKU": "CLR-VDHCH-MB-CR-CC-8540"
    },
    "parent": "19d3c99a-050f-46bf-826c-d61e20d1e751",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-VDHCH-CR",
    "id": "c97e4bc7-e40a-4473-9576-7a60e5958fae",
    "attributes": {
      "defaultSKU": "CLR-VDHCH-CR-CC-8540"
    },
    "parent": "3ee13a9d-6699-4907-b389-6cd1b134999a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PHBSO-CR",
    "id": "62609c77-02df-4e07-9ee8-451aaa8f6bf3",
    "attributes": {
      "defaultSKU": "CLR-PHBSO-CR-CF-CC"
    },
    "parent": "0517a343-c2e1-44b4-a150-5283b6569b4b",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PHBCH-MB-CR",
    "id": "274cd5bd-4510-484c-b31e-c394f2087eec",
    "attributes": {
      "defaultSKU": "CLR-PHBCH-MB-CR-CF-CC-BLU"
    },
    "parent": "1fc98d06-99c1-4bc0-adbe-2c2d30022393",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PHBCH-CR",
    "id": "dec512f4-1a20-4ff6-923f-55d3d0ed663d",
    "attributes": {
      "defaultSKU": "CLR-PHBCH-CR-CF-CC-BLU"
    },
    "parent": "7e157a30-fbae-4142-83ba-8f035bde582b",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PDHCH-CR",
    "id": "67dff707-e3e8-477c-9068-ab68a8b50cf1",
    "attributes": {
      "defaultSKU": "CLR-PDHCH-CR-CC-BLU"
    },
    "parent": "ac1ee47d-c163-44eb-9123-8c4b2873403f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PDHCH-MB-CR",
    "id": "349432d8-5b07-4205-943a-b955eb923a60",
    "attributes": {
      "defaultSKU": "CLR-PDHCH-MB-CR-CC-BLU"
    },
    "parent": "3f07bd6c-7529-4cc6-aae3-7b8ddeda2f8d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PDHSO-CR",
    "id": "a561d2fa-7352-49d5-aac0-7aea9131356f",
    "attributes": {
      "defaultSKU": "CLR-PDHSO-CR-CC"
    },
    "parent": "402d90b8-4c2e-4a58-9923-44f25c00bbfc",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PMBCH-CR",
    "id": "8a5ffe50-6d29-4f31-a9cb-2cf243e80c3a",
    "attributes": {
      "defaultSKU": "CLR-PMBCH-CR-CF-CC-BLU"
    },
    "parent": "5ba3babb-e468-446e-b66e-a3b2e85f96df",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PMBCH-MB-CR",
    "id": "d663cd47-d70f-4050-a790-ef7927aee7a8",
    "attributes": {
      "defaultSKU": "CLR-PMBCH-MB-CR-CF-CC-BLU"
    },
    "parent": "cd32eecf-da2c-4e2c-920a-1c4986e3a40d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "CLR-PMBSO-CR",
    "id": "27624a63-686a-4bd6-b5ad-a1508213077a",
    "attributes": {
      "defaultSKU": "CLR-PMBSO-CR-CF-CC"
    },
    "parent": "33bc4a10-0aca-4fa3-a589-86d8323bf1f7",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Clean Room (Class 100 - ISO5)",
    "id": "5eb60d91-2372-4051-8070-3dd6f4d49964",
    "attributes": {
      "question": "Choose your material"
    },
    "parent": "2d3fff2b-b460-4b99-b157-b0c17fce0fe5",
    "index": 2
  },
  {
    "name": "Polyurethane",
    "id": "6822867d-0c24-4a02-9b89-cddff73d5d6f",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "poly.png"
    },
    "parent": "5eb60d91-2372-4051-8070-3dd6f4d49964",
    "index": 0,
    "type": "image-question"
  },
  {
    "name": "Vinyl",
    "id": "5b071693-3470-42e9-bf96-5d00eb419891",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "vinyl.png"
    },
    "parent": "5eb60d91-2372-4051-8070-3dd6f4d49964",
    "index": 1,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "b4e78f6b-a703-4605-a7d7-4109210374a2",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "6822867d-0c24-4a02-9b89-cddff73d5d6f",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "c3cd23bd-37d7-405e-bd94-e5c7c1c44d3b",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "6822867d-0c24-4a02-9b89-cddff73d5d6f",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "1b257c56-4be0-465d-9145-1af4a8a893b9",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "6822867d-0c24-4a02-9b89-cddff73d5d6f",
    "index": 2
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "93a94883-54d0-41ed-8b24-d2ae2a1e7cd4",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "5b071693-3470-42e9-bf96-5d00eb419891",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "039e13a9-0131-40a6-821e-97ae0e0e56de",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "5b071693-3470-42e9-bf96-5d00eb419891",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "cc3fba84-0649-47fb-aea1-315411810676",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "5b071693-3470-42e9-bf96-5d00eb419891",
    "index": 2
  },
  {
    "name": "Standard Back Chair",
    "id": "8d7c03f3-078d-4db5-bf03-b6ea53c99fa1",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "b4e78f6b-a703-4605-a7d7-4109210374a2",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "686e3ea0-c18b-49fa-9767-e5c024ca86ea",
    "attributes": {
      "image": "poly-med-chair.png"
    },
    "parent": "b4e78f6b-a703-4605-a7d7-4109210374a2",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "1db6ccbf-9a05-4f00-a725-d0cfc4490f19",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "c3cd23bd-37d7-405e-bd94-e5c7c1c44d3b",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "fba15bcc-9552-4ea6-886f-9429d703c132",
    "attributes": {
      "image": "poly-med-chair.png"
    },
    "parent": "c3cd23bd-37d7-405e-bd94-e5c7c1c44d3b",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "f5b8adb0-cf23-42b8-bf80-5961f1940195",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "1b257c56-4be0-465d-9145-1af4a8a893b9",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "0fce176a-4d38-49f1-9357-21b3f275ecee",
    "attributes": {
      "image": "poly-med-chair.png"
    },
    "parent": "1b257c56-4be0-465d-9145-1af4a8a893b9",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "ec96269e-5905-415c-b50f-a4f9096e773b",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "93a94883-54d0-41ed-8b24-d2ae2a1e7cd4",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "49d89d7e-5391-4018-b89d-6b1680789581",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "93a94883-54d0-41ed-8b24-d2ae2a1e7cd4",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "cc9970d0-5996-4373-b213-bcb19812e07b",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "039e13a9-0131-40a6-821e-97ae0e0e56de",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "b6dc061f-9fa4-4c0a-b7ce-08e5e6d0f434",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "039e13a9-0131-40a6-821e-97ae0e0e56de",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "9cbd72fb-24eb-4764-a4ac-08e59c813c9a",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "cc3fba84-0649-47fb-aea1-315411810676",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "6b90244d-e5cf-4d1c-922a-755eec1645f8",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "cc3fba84-0649-47fb-aea1-315411810676",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "NCR-PDHCH-CR",
    "id": "1913d513-0631-45ab-a3c5-c6f3294e76b1",
    "attributes": {
      "defaultSKU": "NCR-PDHCH-CR-T0-A1-CC-BLU"
    },
    "parent": "8d7c03f3-078d-4db5-bf03-b6ea53c99fa1",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-PDHCH-MB-CR",
    "id": "e83e41ea-a32e-4612-8b6c-38281774bb2a",
    "attributes": {
      "defaultSKU": "NCR-PDHCH-MB-CR-T0-A1-CC-BLU"
    },
    "parent": "686e3ea0-c18b-49fa-9767-e5c024ca86ea",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-PMBCH-CR",
    "id": "c6a51139-e7e5-4c7e-b8c8-41b59beee97d",
    "attributes": {
      "defaultSKU": "NCR-PMBCH-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "1db6ccbf-9a05-4f00-a725-d0cfc4490f19",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-PMBCH-MB-CR",
    "id": "542fb90f-bede-482d-8d04-a6ed5b85ce4e",
    "attributes": {
      "defaultSKU": "NCR-PMBCH-MB-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "fba15bcc-9552-4ea6-886f-9429d703c132",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-PHBCH-CR",
    "id": "0775e9a4-607e-40c7-8655-9666e8963506",
    "attributes": {
      "defaultSKU": "NCR-PHBCH-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "f5b8adb0-cf23-42b8-bf80-5961f1940195",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-PHBCH-MB-CR",
    "id": "1bed6ce6-5a34-4a27-8257-ccf59b3b279a",
    "attributes": {
      "defaultSKU": "NCR-PHBCH-MB-CR-T0-A1-CF-CC-BLU"
    },
    "parent": "0fce176a-4d38-49f1-9357-21b3f275ecee",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-VDHCH-CR",
    "id": "32c6e137-e0dd-4662-b618-dfeb7d30e53b",
    "attributes": {
      "defaultSKU": "NCR-VDHCH-CR-T0-A1-CC-8540"
    },
    "parent": "ec96269e-5905-415c-b50f-a4f9096e773b",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-VDHCH-MB-CR",
    "id": "209dd358-69e5-44a2-bb17-a677ef3020fc",
    "attributes": {
      "defaultSKU": "NCR-VDHCH-MB-CR-T0-A1-CC-8540"
    },
    "parent": "49d89d7e-5391-4018-b89d-6b1680789581",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-VMBCH-CR",
    "id": "a4c06874-8f5f-4877-b3e1-75fb3345161f",
    "attributes": {
      "defaultSKU": "NCR-VMBCH-CR-T0-A1-CF-CC-8540"
    },
    "parent": "cc9970d0-5996-4373-b213-bcb19812e07b",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-VMBCH-MB-CR",
    "id": "32b14339-5895-4b1e-8e1a-6b7684816d0f",
    "attributes": {
      "defaultSKU": "NCR-VMBCH-MB-CR-T0-A1-CF-CC-8540"
    },
    "parent": "b6dc061f-9fa4-4c0a-b7ce-08e5e6d0f434",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-VHBCH-CR",
    "id": "53ed29f7-978f-4a09-8d4a-4171f742a013",
    "attributes": {
      "defaultSKU": "NCR-VHBCH-CR-T0-A1-CF-CC-8540"
    },
    "parent": "9cbd72fb-24eb-4764-a4ac-08e59c813c9a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "NCR-VHBCH-MB-CR",
    "id": "5258ca47-fe3d-4e1f-8e3d-b4911610eb88",
    "attributes": {
      "defaultSKU": "NCR-VHBCH-MB-CR-T0-A1-CF-CC-8540"
    },
    "parent": "6b90244d-e5cf-4d1c-922a-755eec1645f8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Clean Room ESD",
    "id": "9b70ede4-5f0b-44f9-aa4e-53ef4e3362e5",
    "attributes": {
      "question": "How tall is your work surface?"
    },
    "parent": "2d3fff2b-b460-4b99-b157-b0c17fce0fe5",
    "index": 3
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "233795f8-d957-4251-a41d-3a4246b44429",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "9b70ede4-5f0b-44f9-aa4e-53ef4e3362e5",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "81430e10-09db-4a7a-b8da-A1a6d0ef185f",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "9b70ede4-5f0b-44f9-aa4e-53ef4e3362e5",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "83f87534-61a3-4b36-8749-423714cc596f",
    "attributes": {
      "question": "What type of back do you prefer?"
    },
    "parent": "9b70ede4-5f0b-44f9-aa4e-53ef4e3362e5",
    "index": 2
  },
  {
    "name": "Standard Back Chair",
    "id": "b4266c0e-e6b6-47c4-a3ac-05f77f02d51d",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "233795f8-d957-4251-a41d-3a4246b44429",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "fb1d2d77-c4d2-40e9-8d98-70f83ef40a60",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "233795f8-d957-4251-a41d-3a4246b44429",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "bf90bde4-7d97-4c69-ad5b-a343a15886b8",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "81430e10-09db-4a7a-b8da-A1a6d0ef185f",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "5cdb4d4c-89b1-48e1-b133-e7c49b2a9049",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "81430e10-09db-4a7a-b8da-A1a6d0ef185f",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "5f7415c3-6953-448b-b0f5-34f971af52f1",
    "attributes": {
      "image": "vinyl-reg-chair.png"
    },
    "parent": "83f87534-61a3-4b36-8749-423714cc596f",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Large Back Chair",
    "id": "21468821-f2aa-4663-be13-b7c958daa600",
    "attributes": {
      "image": "med-chair.png"
    },
    "parent": "83f87534-61a3-4b36-8749-423714cc596f",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "ECR-VDHCH-CR",
    "id": "79859c82-b24d-447b-bf51-76bc6db36db7",
    "attributes": {
      "defaultSKU": "ECR-VDHCH-CR-EC-ESDBLU"
    },
    "parent": "b4266c0e-e6b6-47c4-a3ac-05f77f02d51d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ECR-VDHCH-MB-CR",
    "id": "f92a13d3-5340-4b62-9fb0-b49201578a63",
    "attributes": {
      "defaultSKU": "ECR-VDHCH-MB-CR-EC-ESDBLU"
    },
    "parent": "fb1d2d77-c4d2-40e9-8d98-70f83ef40a60",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ECR-VMBCH-CR",
    "id": "ef6d1320-45df-4f4f-9e6e-e27919271434",
    "attributes": {
      "defaultSKU": "ECR-VMBCH-CR-CF-EC-ESDBLU"
    },
    "parent": "bf90bde4-7d97-4c69-ad5b-a343a15886b8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ECR-VMBCH-MB-CR",
    "id": "b4aae2e6-1bdc-46bc-92fc-24902866b1fb",
    "attributes": {
      "defaultSKU": "ECR-VMBCH-MB-CR-CF-EC-ESDBLU"
    },
    "parent": "5cdb4d4c-89b1-48e1-b133-e7c49b2a9049",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ECR-VHBCH-CR",
    "id": "40b2e4a9-6b0b-498e-bebd-0ac702e776a1",
    "attributes": {
      "defaultSKU": "ECR-VHBCH-CR-CF-EC-ESDBLU"
    },
    "parent": "5f7415c3-6953-448b-b0f5-34f971af52f1",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ECR-VHBCH-MB-CR",
    "id": "59dc8bae-d619-4dc8-ba87-a837ecbd4ddf",
    "attributes": {
      "defaultSKU": "ECR-VHBCH-MB-CR-CF-EC-ESDBLU"
    },
    "parent": "21468821-f2aa-4663-be13-b7c958daa600",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Shell",
    "id": "d384b966-5ef9-4c25-8f1d-1be07830202a",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "shell.png"
    },
    "parent": "fd4985b3-338c-4414-a980-8f1521d58d46",
    "index": 5,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "e76ba333-5af4-4d03-a438-1bee38d003b8",
    "attributes": {
      "question": "What type of base do you prefer?"
    },
    "parent": "d384b966-5ef9-4c25-8f1d-1be07830202a",
    "index": 0,
    "type": "text-question"
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "ba7b1090-1e6a-41c8-8ce1-c6cc351c6a60",
    "attributes": {
      "question": "What type of base do you prefer?"
    },
    "parent": "d384b966-5ef9-4c25-8f1d-1be07830202a",
    "index": 1,
    "type": "text-question"
  },
  {
    "name": "Black Nylon Base",
    "id": "b6cf2e65-63c6-4802-a36e-9606cbe7a662",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "e76ba333-5af4-4d03-a438-1bee38d003b8",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "e9279108-08f9-43ab-9118-be4eeff9d38e",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "e76ba333-5af4-4d03-a438-1bee38d003b8",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "10b9d252-56ba-4d98-8211-f05eb021414f",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "e76ba333-5af4-4d03-a438-1bee38d003b8",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "9f6d198d-647c-4def-9417-de34bc6ba3b4",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "ba7b1090-1e6a-41c8-8ce1-c6cc351c6a60",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Chrome Base",
    "id": "76234397-2f54-49fd-927f-6cc3e0d8b0f4",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "ba7b1090-1e6a-41c8-8ce1-c6cc351c6a60",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "9cceda95-3531-439a-9300-96366838b1b7",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "ba7b1090-1e6a-41c8-8ce1-c6cc351c6a60",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "SDHCH-RG",
    "id": "a68e4e81-cf4c-4fbf-9edc-5e6e06d7b03d",
    "attributes": {
      "defaultSKU": "SDHCH-RG-RC-BLK"
    },
    "parent": "b6cf2e65-63c6-4802-a36e-9606cbe7a662",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "SDHCH-CR",
    "id": "97091de6-34bd-4101-b3e6-eff9bfbb9150",
    "attributes": {
      "defaultSKU": "SDHCH-CR-CC-BLK"
    },
    "parent": "e9279108-08f9-43ab-9118-be4eeff9d38e",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "SDHCH-RT",
    "id": "c96666d9-aff1-4f5d-bcca-de00aaee62a6",
    "attributes": {
      "defaultSKU": "SDHCH-RT-RG-BLK"
    },
    "parent": "10b9d252-56ba-4d98-8211-f05eb021414f",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "SMBCH-RG",
    "id": "5789d42c-2b49-44b8-9887-9f10478c42e0",
    "attributes": {
      "defaultSKU": "SMBCH-RG-CF-RC-BLK"
    },
    "parent": "9f6d198d-647c-4def-9417-de34bc6ba3b4",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "SMBCH-CR",
    "id": "13561cf3-a8ad-4e48-ba89-98681e32311b",
    "attributes": {
      "defaultSKU": "SMBCH-CR-CF-CC-BLK"
    },
    "parent": "76234397-2f54-49fd-927f-6cc3e0d8b0f4",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "SMBCH-RT",
    "id": "65e147c6-ea6d-4f89-a3f1-8a827e7babb8",
    "attributes": {
      "defaultSKU": "SMBCH-RT-RG-BLK"
    },
    "parent": "9cceda95-3531-439a-9300-96366838b1b7",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "With seat tilt",
    "id": "e311421c-49a8-4175-91df-7d186226f68a",
    "attributes": {},
    "parent": "cc09fd4b-d99a-4da1-8767-fbe7fe761b2e",
    "index": 0,
    "type": "title-only"
  },
  {
    "name": "Without seat tilt",
    "id": "cf3a5f88-3c49-43f2-80e3-179aa928276b",
    "attributes": {},
    "parent": "cc09fd4b-d99a-4da1-8767-fbe7fe761b2e",
    "index": 1,
    "type": "title-only"
  },
  {
    "name": "PTDHSO-RG",
    "id": "64cd039b-8262-491a-af81-f8c484ef27ff",
    "attributes": {
      "defaultSKU": "PTDHSO-RG-RC-BLU"
    },
    "parent": "e311421c-49a8-4175-91df-7d186226f68a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PTDHSL-RG",
    "id": "0a7be7fe-44fe-4b6c-944c-e4cb1113a1d7",
    "attributes": {
      "defaultSKU": "PTDHSL-RG-RC-BLU"
    },
    "parent": "cf3a5f88-3c49-43f2-80e3-179aa928276b",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Without seat tilt",
    "id": "4e6db507-d43b-4411-b8f5-7496e98fe5a4",
    "attributes": {},
    "parent": "ad23d1da-e424-4680-b258-e7547b4bf83b",
    "index": 1,
    "type": "title-only"
  },
  {
    "name": "With seat tilt",
    "id": "aaf80cca-c4ab-40b7-a010-d85fa73ed050",
    "attributes": {},
    "parent": "ad23d1da-e424-4680-b258-e7547b4bf83b",
    "index": 0,
    "type": "title-only"
  },
  {
    "name": "PTDHSL-CR",
    "id": "503ffb43-5b11-4f02-8876-99d18931b7f0",
    "attributes": {
      "defaultSKU": "PTDHSL-CR-CC-BLU"
    },
    "parent": "4e6db507-d43b-4411-b8f5-7496e98fe5a4",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PTDHSO-CR",
    "id": "e2af7ab5-5657-4262-9a77-ff341c866e95",
    "attributes": {
      "defaultSKU": "PTDHSO-CR-CC-BLU"
    },
    "parent": "aaf80cca-c4ab-40b7-a010-d85fa73ed050",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "With seat tilt",
    "id": "bc3f8b0d-99ab-435e-b891-0e2e7cfa6e92",
    "attributes": {},
    "parent": "46f1b833-81a4-4eb5-99a5-03456a7e573f",
    "index": 0,
    "type": "title-only"
  },
  {
    "name": "Without seat tilt",
    "id": "0b994181-dd77-4133-96bf-11d6f5c7cab6",
    "attributes": {},
    "parent": "46f1b833-81a4-4eb5-99a5-03456a7e573f",
    "index": 1,
    "type": "title-only"
  },
  {
    "name": "PTMBSO-CR",
    "id": "4373018c-af98-4fc8-bc64-4f0815e54259",
    "attributes": {
      "defaultSKU": "PTMBSO-CR-CF-CC-BLU"
    },
    "parent": "bc3f8b0d-99ab-435e-b891-0e2e7cfa6e92",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PTMBSL-CR",
    "id": "8def7a11-ce65-4417-8401-6bc864df7500",
    "attributes": {
      "defaultSKU": "PTMBSL-CR-CF-CC-BLU"
    },
    "parent": "0b994181-dd77-4133-96bf-11d6f5c7cab6",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Without seat tilt",
    "id": "1c764148-beab-4561-a2a8-80c739d56b99",
    "attributes": {},
    "parent": "ab4793c8-e698-428b-a909-f7539d54893b",
    "index": 1,
    "type": "title-only"
  },
  {
    "name": "PTMBSO-RG",
    "id": "6ed8a981-67c7-48c8-ba85-b2f046c441c2",
    "attributes": {
      "defaultSKU": "PTMBSO-RG-CF-RC-BLU"
    },
    "parent": "ca770a9a-3f56-40e1-b08b-ed4bdc402306",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "PTMBSL-RG",
    "id": "2bc1c447-5c33-4b28-a03d-1c454ccba27b",
    "attributes": {
      "defaultSKU": "PTMBSL-RG-CF-RC-BLU"
    },
    "parent": "1c764148-beab-4561-a2a8-80c739d56b99",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Hybrid (Mesh + Vinyl)",
    "id": "177e0fe4-2083-47e2-80e0-d3e5db7ea3a6",
    "attributes": {
      "image": "windova.png"
    },
    "parent": "4ced1c6b-59c4-4142-92cf-d14a79865884",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "EXE-VMDHCH-RG",
    "id": "eb159b2b-cfc4-41f0-a1bc-294a4062546a",
    "attributes": {
      "defaultSKU": "EXE-VMDHCH-RG-H0-A2-RC-8815"
    },
    "parent": "177e0fe4-2083-47e2-80e0-d3e5db7ea3a6",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Hybrid (Mesh + Vinyl)",
    "id": "5c2b2333-919f-4157-b98a-a7751d29d6bb",
    "attributes": {
      "image": "windova.png"
    },
    "parent": "6db9fcd8-ea71-48f5-8eee-0f7166be5d8a",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "GEXE-VMDHCH-RG",
    "id": "60508215-809b-47db-80ea-2bc405946a15",
    "attributes": {
      "defaultSKU": "GEXE-VMDHCH-RG-H0-A1-RG-8815"
    },
    "parent": "5c2b2333-919f-4157-b98a-a7751d29d6bb",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Handle Back Chair",
    "id": "4c1220b1-4c9b-4129-8cd1-52388fb683fa",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "handle-poly.png"
    },
    "parent": "B987FE6F-AA9F-4564-A2BB-2182C4047781",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "9eb49858-bfc9-4190-b69a-c38877826eec",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "4c1220b1-4c9b-4129-8cd1-52388fb683fa",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Round Tube Base",
    "id": "693e75a6-8044-4d4b-ae94-ac9ab7739a9a",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "4c1220b1-4c9b-4129-8cd1-52388fb683fa",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "c775a68f-cdf5-446d-bed5-9e2f85f84283",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "4c1220b1-4c9b-4129-8cd1-52388fb683fa",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "HPMBCH-CR",
    "id": "44f881c0-7854-4635-8010-41b6e0bd3a35",
    "attributes": {
      "defaultSKU": "HPMBCH-CR-T0-A0-CF-CC-BLU"
    },
    "parent": "9eb49858-bfc9-4190-b69a-c38877826eec",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "HPMBCH-RT",
    "id": "be169c8c-d840-4578-aeda-e99f0a7bbd7d",
    "attributes": {
      "defaultSKU": "HPMBCH-RT-T0-A0-RC-BLU"
    },
    "parent": "693e75a6-8044-4d4b-ae94-ac9ab7739a9a",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "HPMBCH-RG",
    "id": "2ad7667f-06bc-4855-bcc4-dd62b5d5fed1",
    "attributes": {
      "defaultSKU": "HPMBCH-RG-T0-A0-CF-RC-BLU"
    },
    "parent": "c775a68f-cdf5-446d-bed5-9e2f85f84283",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Handle Back Chair",
    "id": "e989b28f-dc83-404f-a110-349d2cf99314",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "handle-poly.png"
    },
    "parent": "163CEB8A-1CA9-49F6-80CC-DF765C08217E",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "63f2b987-9801-4366-a80d-38c044d3c067",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "e989b28f-dc83-404f-a110-349d2cf99314",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "HPDHCH-CR",
    "id": "135d0d1e-d0a6-4be9-ad13-39ccfa1ce5d5",
    "attributes": {
      "defaultSKU": "HPDHCH-CR-T0-A0-CC-BLU"
    },
    "parent": "63f2b987-9801-4366-a80d-38c044d3c067",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Round Tube Base",
    "id": "cb1915b8-1819-44ca-b25c-006aa696f672",
    "attributes": {
      "image": "round-base.png"
    },
    "parent": "e989b28f-dc83-404f-a110-349d2cf99314",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "531330b4-e05b-4e99-a1ad-fab554053457",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "e989b28f-dc83-404f-a110-349d2cf99314",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "HPDHCH-RT",
    "id": "f4595135-3a87-4266-aa93-3ed51ad25e06",
    "attributes": {
      "defaultSKU": "HPDHCH-RT-T0-A0-RC-BLU"
    },
    "parent": "cb1915b8-1819-44ca-b25c-006aa696f672",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "HPDHCH-RG",
    "id": "cfcef1fb-7d4f-4bd0-977b-221635f80f7d",
    "attributes": {
      "defaultSKU": "HPDHCH-RG-T0-A0-RC-BLU"
    },
    "parent": "531330b4-e05b-4e99-a1ad-fab554053457",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Handle Back Chair",
    "id": "588065af-4293-442f-9ec8-e3f670b2bce6",
    "attributes": {
      "question": "What type of base do you prefer?",
      "image": "handle-poly.png"
    },
    "parent": "4233B7F4-F468-4175-883C-86DAEA04A9DF",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Chrome Base",
    "id": "9ade9da1-1c24-4104-85ba-de6087221a9d",
    "attributes": {
      "image": "chrome-base.png"
    },
    "parent": "588065af-4293-442f-9ec8-e3f670b2bce6",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Black Nylon Base",
    "id": "57ae8676-54c1-4e79-af3d-da04bf13abdf",
    "attributes": {
      "image": "black-base.png"
    },
    "parent": "588065af-4293-442f-9ec8-e3f670b2bce6",
    "index": 2,
    "type": "title-&-image"
  },
  {
    "name": "HPHBCH-CR",
    "id": "55e2e0b4-2fb2-4d89-a937-bb9dddb10c09",
    "attributes": {
      "defaultSKU": "HPHBCH-CR-T0-A0-CF-CC-BLU"
    },
    "parent": "9ade9da1-1c24-4104-85ba-de6087221a9d",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "HPHBCH-RG",
    "id": "1de878eb-f364-4f96-98fd-fbf7ea96fcd4",
    "attributes": {
      "defaultSKU": "HPHBCH-RG-T0-A0-CF-RC-BLU"
    },
    "parent": "57ae8676-54c1-4e79-af3d-da04bf13abdf",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Polyurethane",
    "id": "d1fad27b-be54-4553-9e76-2b05ed0a2160",
    "attributes": {
      "question": "How tall is your work surface?",
      "image": "poly.png"
    },
    "parent": "7ff6bf4a-a74b-4522-808e-307f49c5a004",
    "index": 2,
    "type": "image-question"
  },
  {
    "name": "Desk Height (29\\"-31\\")",
    "id": "52df4216-624d-4a4b-ae12-a45198049655",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "d1fad27b-be54-4553-9e76-2b05ed0a2160",
    "index": 0
  },
  {
    "name": "Medium Bench (32\\"-36\\")",
    "id": "79ef24c0-e487-4ad2-bdd3-ae4ed23dfcf2",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "d1fad27b-be54-4553-9e76-2b05ed0a2160",
    "index": 1
  },
  {
    "name": "High Bench (37\\"-42\\")",
    "id": "c9455734-a522-4248-8b4c-3e98c6dfd767",
    "attributes": {
      "question": "What type of seating do you prefer?"
    },
    "parent": "d1fad27b-be54-4553-9e76-2b05ed0a2160",
    "index": 2
  },
  {
    "name": "",
    "id": "bbd6becb-d23f-48c2-ae9e-9cb7d59dddbc",
    "attributes": {
      "question": ""
    },
    "parent": "66c9debb-be4d-46d1-80cd-1660db1cf0ed",
    "index": 0
  },
  {
    "name": "Standard Back Chair",
    "id": "14c6acae-462c-42ad-b665-28343cbab528",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "52df4216-624d-4a4b-ae12-a45198049655",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "Tractor Stool",
    "id": "e8efa1b8-ba5f-4155-bded-3e4a818ca5ec",
    "attributes": {
      "image": "tractor-stool.png"
    },
    "parent": "52df4216-624d-4a4b-ae12-a45198049655",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "ESD-PTDHSO-CR",
    "id": "b6031576-d450-4b7a-ae02-949e8e06bf86",
    "attributes": {
      "defaultSKU": "ESD-PTDHSO-CR-EC"
    },
    "parent": "e8efa1b8-ba5f-4155-bded-3e4a818ca5ec",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-PDHCH-CR",
    "id": "477a26ad-15ce-4d55-855b-035434d8ea42",
    "attributes": {
      "defaultSKU": "ESD-PDHCH-CR-T0-A0-EC"
    },
    "parent": "14c6acae-462c-42ad-b665-28343cbab528",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Tractor Stool",
    "id": "96fbf4f2-2aee-4413-b1b8-c71bfa1570e8",
    "attributes": {
      "image": "tractor-stool.png"
    },
    "parent": "79ef24c0-e487-4ad2-bdd3-ae4ed23dfcf2",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "55d9c792-5d19-4c53-8095-77a692d28035",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "79ef24c0-e487-4ad2-bdd3-ae4ed23dfcf2",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "ESD-PTMBSO-CR",
    "id": "3077f65a-2c84-47c7-91b2-07a25fcce819",
    "attributes": {
      "defaultSKU": "ESD-PTMBSO-CR-CF-EC"
    },
    "parent": "96fbf4f2-2aee-4413-b1b8-c71bfa1570e8",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-PMBCH-CR",
    "id": "049bb2f4-dab7-4a39-8b1c-b402c1a868af",
    "attributes": {
      "defaultSKU": "ESD-PMBCH-CR-T0-A0-NF-EC"
    },
    "parent": "55d9c792-5d19-4c53-8095-77a692d28035",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "Tractor Stool",
    "id": "8d331c5b-a252-4d71-b6a4-ddcbc9b5ad53",
    "attributes": {
      "image": "tractor-stool.png"
    },
    "parent": "c9455734-a522-4248-8b4c-3e98c6dfd767",
    "index": 0,
    "type": "title-&-image"
  },
  {
    "name": "Standard Back Chair",
    "id": "2bac3e0d-e403-4c96-bb0c-be14a5d6f305",
    "attributes": {
      "image": "poly-reg-chair.png"
    },
    "parent": "c9455734-a522-4248-8b4c-3e98c6dfd767",
    "index": 1,
    "type": "title-&-image"
  },
  {
    "name": "ESD-PTHBST-CR",
    "id": "55f689aa-b79c-492d-a563-a5bd0eebf6b7",
    "attributes": {
      "defaultSKU": "ESD-PTHBST-CR-NF-EG"
    },
    "parent": "8d331c5b-a252-4d71-b6a4-ddcbc9b5ad53",
    "index": 0,
    "type": "leaf"
  },
  {
    "name": "ESD-PHBCH-CR",
    "id": "ba7e9c1b-9f96-4f02-a3f2-5c18cfdce199",
    "attributes": {
      "defaultSKU": "ESD-PHBCH-CR-T0-A0-CF-EC"
    },
    "parent": "2bac3e0d-e403-4c96-bb0c-be14a5d6f305",
    "index": 0,
    "type": "leaf"
  }
]
`
